import { SVGProps } from 'react';

/**
 * SVG Icon Components - Others/Common Ingredients
 * Common ingredient icons that users can add for non-standard items
 * Users can provide their own SVG icons for these placeholders
 */

export const othersIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  // Sweet spreads & toppings
  nutella: (props) => (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Layer_1" data-name="Layer 1">
        <path
          d="m6.5 8.5a1 1 0 0 1 -1-1v-1a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 0 1 -1 1z"
          fill="#ff3446"
        ></path>
        <path
          d="m7.5 20.5a3 3 0 0 1 -3-3v-4.077a3.984 3.984 0 0 1 1.5-3.123l1-.8v-1h11v1l1 .8a3.984 3.984 0 0 1 1.5 3.124v4.076a3 3 0 0 1 -3 3z"
          fill="#a64700"
        ></path>
        <path
          d="m8.5 17.5a1 1 0 0 1 -1-1v-1.588a3.413 3.413 0 0 1 3.412-3.412h3.176a3.413 3.413 0 0 1 3.412 3.412v1.588a1 1 0 0 1 -1 1z"
          fill="#ffdc00"
        ></path>
      </g>
      <g id="Layer_2_copy" data-name="Layer 2 copy">
        <path d="m18.5 9h-12a1.5 1.5 0 0 1 -1.5-1.5v-1a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v1a1.5 1.5 0 0 1 -1.5 1.5zm-11-4a1.5 1.5 0 0 0 -1.5 1.5v1a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0 -1.5-1.5z"></path>
        <path d="m17.5 21h-10a3.5 3.5 0 0 1 -3.5-3.5v-4.077a4.484 4.484 0 0 1 1.688-3.515l.812-.648v-.76a.5.5 0 0 1 1 0v1a.5.5 0 0 1 -.188.391l-1 .8a3.488 3.488 0 0 0 -1.312 2.732v4.077a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5v-4.077a3.488 3.488 0 0 0 -1.313-2.734l-1-.8a.5.5 0 0 1 -.187-.389v-1a.5.5 0 0 1 1 0v.76l.812.648a4.484 4.484 0 0 1 1.688 3.515v4.077a3.5 3.5 0 0 1 -3.5 3.5z"></path>
        <path
          d="m16.5 18h-8a1.5 1.5 0 0 1 -1.5-1.5v-1.588a3.913 3.913 0 0 1 3.912-3.912h3.176a3.912 3.912 0 0 1 3.912 3.912v1.588a1.5 1.5 0 0 1 -1.5 1.5zm-5.588-6a2.914 2.914 0 0 0 -2.912 2.912v1.588a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1.588a2.913 2.913 0 0 0 -2.912-2.912z"
          fill="#ff8c00"
        ></path>
      </g>
    </svg>
  ),
  pistachio: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <path
              d="m190.461 268.648c-17.672 79.616-64.519 136.938-104.636 128.034-40.116-8.905-58.311-80.665-40.638-160.28 10.398-46.846 17.804-73.512 42.085-94.933 10.541-9.299 26.412-12.467 33.925-15.062 20.636-7.127 21.833-13.563 35.46-12.479 31.266 2.488 51.476 75.104 33.804 154.72z"
              fill="#bade7a"
            ></path>
            <path
              d="m156.658 113.927c-10.868-.865-13.83 3.054-25.052 8.292 21.327 21.509 32.026 81.652 17.647 146.429-13.398 60.36-43.565 107.906-74.855 123.494 3.578 2.112 7.391 3.644 11.426 4.54 40.116 8.905 86.963-48.418 104.636-128.034s-2.537-152.232-33.802-154.721z"
              fill="#aad167"
            ></path>
            <g>
              <path
                d="m1.28 249.681c-13.52 125.232 84.545 147 84.545 147l1.56-275.001c.04-7.014-8.316-10.944-13.779-6.466-22.316 18.292-64.486 61.842-72.326 134.467z"
                fill="#ffd9bb"
              ></path>
            </g>
            <g>
              <path
                d="m224.68 299.27c-40.735 119.191-138.8 97.424-138.8 97.424l114.939-249.834c2.932-6.373 12.165-6.397 15.22-.029 12.481 26.015 32.265 83.317 8.641 152.439z"
                fill="#ffc597"
              ></path>
            </g>
          </g>
          <g>
            <path
              d="m451.856 114.103c39.126 71.558 41.609 145.536 5.548 165.235-36.062 19.699-97.013-22.34-136.139-93.898-23.022-42.104-35.008-67.05-30.835-99.154 1.811-13.937 11.671-26.767 15.619-33.665 10.841-18.946 7.503-24.578 18.475-32.73 25.173-18.703 88.207 22.655 127.332 94.212z"
              fill="#bade7a"
            ></path>
            <path
              d="m451.856 114.103c-39.125-71.557-102.159-112.915-127.333-94.211-.803.597-1.529 1.179-2.189 1.755 28.435 13.226 63.272 46.655 88.315 92.456 28.718 52.523 51.435 123.265 47.227 164.973 35.567-20.086 32.934-93.729-6.02-164.973z"
              fill="#aad167"
            ></path>
            <g>
              <path
                d="m296.959 224.334c72.291 103.16 160.445 55.005 160.445 55.005l-179.921-208.02c-4.589-5.306-13.466-2.764-14.63 4.201-4.753 28.455-7.818 88.988 34.106 148.814z"
                fill="#ffc597"
              ></path>
            </g>
            <g>
              <path
                d="m497.781 114.631c47.827 116.525-40.328 164.68-40.328 164.68l-78-263.695c-1.99-6.726 4.944-12.822 11.438-10.039 26.527 11.368 79.154 41.479 106.89 109.054z"
                fill="#ffd9bb"
              ></path>
            </g>
          </g>
          <g>
            <path
              d="m357.098 425.847c-57.754 57.667-128.129 80.896-157.186 51.883s-5.793-99.281 51.961-156.948c33.983-33.931 54.581-52.449 86.596-57.498 13.898-2.191 28.994 3.644 36.73 5.483 21.247 5.051 25.721.265 36.635 8.484 25.042 18.857 3.019 90.929-54.736 148.596z"
              fill="#bade7a"
            ></path>
            <path
              d="m411.835 277.251c-10.914-8.219-15.388-3.433-36.635-8.484-7.736-1.839-22.832-7.674-36.73-5.483-6.38 1.006-12.306 2.547-17.975 4.639 1.167.327 2.238.616 3.196.844 21.247 5.051 25.721.265 36.635 8.484 25.041 18.858 3.018 90.929-54.737 148.596-30.459 30.413-64.428 51.247-93.995 59.891 33.515 15.158 94.442-8.906 145.504-59.891 57.755-57.667 79.778-129.739 54.737-148.596z"
              fill="#aad167"
            ></path>
            <g>
              <path
                d="m207.68 308.445c-78.798 98.362-7.768 169.284-7.768 169.284l149.3-231.072c3.808-5.894-1.128-13.686-8.146-12.839-28.672 3.464-87.689 17.584-133.386 74.627z"
                fill="#ffd9bb"
              ></path>
            </g>
            <g>
              <path
                d="m369.493 470.013c-98.511 78.679-169.541 7.756-169.541 7.756l231.423-149.074c5.903-3.802 13.707 1.126 12.858 8.134-3.469 28.629-17.611 87.556-74.74 133.184z"
                fill="#ffc597"
              ></path>
            </g>
          </g>
        </g>
        <g>
          <path
            d="m38.09 256.648c.358-4.249-2.795-7.985-7.044-8.347-4.257-.355-7.991 2.792-8.354 7.044-.123 1.445-2.866 35.741 9.795 66.765 1.222 2.995 4.109 4.809 7.156 4.809.972 0 1.961-.185 2.917-.575 3.951-1.612 5.847-6.122 4.234-10.073-11.223-27.5-8.731-59.305-8.704-59.623z"
            fill="#ffc597"
          ></path>
          <path
            d="m475.687 119.352c-2.351-3.544-7.113-4.507-10.668-2.174s-4.546 7.117-2.23 10.683c.133.205 13.321 20.962 12.151 57.94-.135 4.265 3.213 7.832 7.478 7.967.083.003.166.004.249.004 4.154 0 7.586-3.3 7.718-7.482 1.336-42.251-14.043-65.95-14.698-66.938z"
            fill="#ffc597"
          ></path>
          <path
            d="m330.792 450.627c-27.046 19.585-56.766 18.141-57.196 18.12-4.256-.27-7.913 2.968-8.184 7.22-.272 4.259 2.961 7.931 7.219 8.202.224.014 1.242.072 2.924.072 9.083 0 37.501-1.692 64.3-21.098 3.456-2.503 4.229-7.334 1.726-10.79-2.502-3.455-7.331-4.228-10.789-1.726z"
            fill="#e89e72"
          ></path>
        </g>
      </g>
    </svg>
  ),
  chocolate: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m128 24h256v280h-256z" fill="#663c28"></path>
      <path d="m384 280-32 32v64l32 32z" fill="#ad6643"></path>
      <path d="m120 280h272v208h-272z" fill="#eb423f"></path>
      <path d="m120 488 32-32v-176h-32z" fill="#d13330"></path>
      <path d="m392 488-32-32v-144h32z" fill="#d13330"></path>
      <path d="m120 280 40 48 248 32-16-80z" fill="#f7cca9"></path>
      <path d="m152 456h208l32 32h-272z" fill="#962523"></path>
      <path d="m160 56h64v64h-64z" fill="#8c5237"></path>
      <path d="m288 56h64v64h-64z" fill="#8c5237"></path>
      <g fill="#ad6643">
        <path d="m256 24-32 32v64l32 32z"></path>
        <path d="m128 24 32 32h64l32-32z"></path>
        <path d="m384 24-32 32v64l32 32z"></path>
        <path d="m256 24 32 32h64l32-32z"></path>
      </g>
      <path d="m160 184h64v64h-64z" fill="#8c5237"></path>
      <path d="m288 184h64v64h-64z" fill="#8c5237"></path>
      <path d="m256 152-32 32v64l32 32z" fill="#ad6643"></path>
      <path d="m128 152 32 32h64l32-32z" fill="#ad6643"></path>
      <path d="m384 152-32 32v64l32 32z" fill="#ad6643"></path>
      <path d="m256 152 32 32h64l32-32z" fill="#ad6643"></path>
    </svg>
  ),
  caramel: (props) => (
    <svg
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m112.22 260.625c0 56.35-106.815 72.804-106.815 123.766 0 21.384 16.168 37.209 52.745 33.741 4.001-.379 12.491.338 12.491.338 5.697-1.152 11.689-2.744 17.955-4.832 31.998-10.666 54.514-14.908 73.38-13.893 0 0 2.409-.025 3.471.068 3.908.342 9.847.362 13.514 1.157 9.806 2.128 19.362 4.224 28.893 9.308 11.679 5.682 29.711 23.21 52.527 31.802 12.018 4.526 14.519 3.879 32.401-.167 8.803-6.048 14.79-15.903 15.74-26.736 1.308-15.289 14.071-25.146 27.996-24.369 0 0 2.07.037 2.921.163 5.209.774 11.252 1.964 16.083 6.024 24.129 20.277 50.029 45.607 74.512 33.305 1.978-.994 8.627-.309 8.627-.309 22.808-17.182-2.809-50.519 17.539-75.543 18.08-22.236 55.8-21.415 55.8-53.35 0-19.974-11.968-34.776-54.6-34.776-21.813 0-38.626-3.711-47.861-17.993z"
          fill="#fcc16d"
        ></path>
        <path
          d="m41.207 385.819c0 14.969 10.55 27.614 29.433 32.652-44.143 8.931-70.64-8.927-70.64-32.652 0-50.953 102.462-68.847 102.462-125.198l41.166-1.648.041 1.648c0 56.351-102.462 74.245-102.462 125.198z"
          fill="#fca62f"
        ></path>
        <g>
          <path
            d="m417.697 338.43h-25.755c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h25.755c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
            fill="#f98824"
          ></path>
        </g>
        <g>
          <path
            d="m138.845 338.43h-25.755c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h25.755c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
            fill="#f98824"
          ></path>
        </g>
        <path
          d="m391.943 338.43c-63.274 0-63.274-20.604-126.547-20.604-63.274 0-63.274 20.604-126.548 20.604l-32.688-69.898s8.342-5.983 12.298-8.054l161.726-85.517c1.988-1.04 13.881 0 13.881 0l49.277 55.654z"
          fill="#fca62f"
        ></path>
        <g fill="#f98824">
          <path d="m409.539 248.33c0 35.294-17.596 40.497-17.596 90.1l-97.878-163.469c.67-1.381-7.288-9.502-7.288-9.502v-91.14s7.752-3.993 6.773-5.549z"></path>
          <circle cx="291.788" cy="317.831" r="20.915"></circle>
          <circle cx="327.939" cy="321.433" r="15.403"></circle>
          <circle cx="180.703" cy="334.265" r="15.403"></circle>
        </g>
        <path
          d="m295.106 74.23v102.469l-177.562 93.049c-3.956 2.071-8.365 1.298-11.383-1.216-2.225-1.844-3.698-4.636-3.698-7.912v-96.239c0-3.832 2.122-7.345 5.522-9.117l172.04-90.161c5.007-2.627 10.745-.68 13.475 3.585l.052.082c.977 1.556 1.554 3.41 1.554 5.46z"
          fill="#fcc16d"
        ></path>
        <g fill="#fca62f">
          <path d="m246.213 412.603c10.178 4.955 27.252 19.874 46.567 29.31-8.818 6.099-20.38 8.302-32.444 3.759-22.808-8.592-43.649-27.382-55.331-33.069-14.938-7.963-28.907-12.568-45.998-12.98h36.613c1.349-.031 2.678-.031 3.987 0h.979l-.021.01c16.927.474 30.814 5.058 45.648 12.97z"></path>
          <path d="m438.659 429.992c.001.002 0-.003 0 0-1.55 1.181-3.286 2.253-5.304 3.267-24.477 12.3-54.847-14.793-78.974-35.078-6.099-5.12-12.919-7.417-19.398-7.417h27.081c15.852 0 31.211 5.452 43.551 15.401 11.385 9.177 25.206 19.826 33.044 23.827z"></path>
        </g>
      </g>
    </svg>
  ),
  // Meats & Proteins
  maakouda: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Placeholder - user will provide SVG */}
      <rect width="512" height="512" fill="#daa520" />
      <text x="256" y="256" textAnchor="middle" fill="white" fontSize="40" fontWeight="bold">
        M
      </text>
    </svg>
  ),
  tuna: (props) => (
    <svg viewBox="0 0 55 55" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <path
              d="m5.4298782 18.7308922h-1.6814134v20.9468765c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468765z"
              fill="#d5d3d4"
            ></path>
          </g>
          <g>
            <path
              d="m30.9857845 27.1586342v.0000229c0 7.2873306-5.9075508 13.1948814-13.1948833 13.1948814h-9.6740799c-1.9780579 0-2.6746974 2.6099319-.965611 3.605793 4.1490302 2.4175835 11.7045918 4.035305 20.3480434 4.035305 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468765h-11.8365168c-4.6545143 0-8.4277439 3.7732296-8.4277439 8.427742z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m5.4298782 15.3222141h-1.6814134v20.9468784c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784z"
              fill="#63affa"
            ></path>
          </g>
          <g>
            <path
              d="m30.9857845 23.7499561v.0000229c0 7.2873325-5.9075508 13.1948833-13.1948833 13.1948833h-9.6740799c-1.9780579 0-2.6746974 2.6099319-.965611 3.605793 4.1490302 2.4175797 11.7045918 4.035305 20.3480434 4.035305 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784h-11.8365168c-4.6545143 0-8.4277439 3.7732296-8.4277439 8.427742z"
              fill="#529ffb"
            ></path>
          </g>
          <g>
            <path
              d="m5.4298782 15.3222141h-1.6814134v20.9468784c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784z"
              fill="#63affa"
            ></path>
          </g>
          <g>
            <path
              d="m30.9857845 23.7499561v.0000229c0 7.2873325-5.9075508 13.1948833-13.1948833 13.1948833h-9.6740799c-1.9780579 0-2.6746974 2.6099319-.965611 3.605793 4.1490302 2.4175797 11.7045918 4.035305 20.3480434 4.035305 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784h-11.8365168c-4.6545143 0-8.4277439 3.7732296-8.4277439 8.427742z"
              fill="#529ffb"
            ></path>
          </g>
          <g>
            <ellipse cx="27.499" cy="15.322" fill="#e7e7e7" rx="23.751" ry="8.317"></ellipse>
          </g>
          <g>
            <ellipse cx="27.499" cy="15.322" fill="#d5d3d4" rx="22.069" ry="7.108"></ellipse>
          </g>
          <g>
            <path
              d="m29.0736942 14.8538923h-3.8925285c-1.1638851 0-1.9982204-.9269915-1.6626205-1.8472567l.8536015-2.3406925c.2209091-.6057634.8964939-1.0203838 1.6626205-1.0203838h2.1853275c.7661247 0 1.4417095.4146204 1.6626186 1.0203838l.8536015 2.3406925c.3356018.9202653-.4987355 1.8472567-1.6626206 1.8472567z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m39.3425179 12.5343056v.0000086c0 2.8541832-2.3137741 5.1679564-5.1679573 5.1679564h-27.4499183c3.0420556 2.7534161 11.1819878 4.72822 20.7746124 4.72822 12.1885166 0 22.0692959-3.1825085 22.0692959-7.1082764 0-2.0489769-2.6993256-3.891921-7.0088234-5.1878338-1.5995336-.4809981-3.2172093.7296342-3.2172093 2.3999252z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m42.6123238 39.6935921c-.2304688-.6416016.1035156-1.3486328.7460747-1.578125 2.3174019-.8300781 3.8154488-2.0039063 3.8154488-2.9892578 0-.6816406.5527344-1.234375 1.234375-1.234375s1.234375.5527344 1.234375 1.234375c0 2.1669922-1.9355469 4.0546875-5.4521484 5.3134766-.6268426.2283515-1.3442537-.0925256-1.5781251-.7460938z"
              fill="#82c8fb"
            ></path>
          </g>
          <g>
            <path
              d="m10.6738482 14.1789427c-.4140625 0-.8076172-.2431641-.9794922-.6494141-.2275391-.5410156.0253906-1.1640625.5664063-1.3925781 3.9248047-1.65625 9.3642588-2.6445313 14.5498056-2.6445313.5869141 0 1.0625.4755859 1.0625 1.0625s-.4755859 1.0625-1.0625 1.0625c-4.9160156 0-10.046876.9267578-13.7236338 2.4785156-.1347656.0566407-.2744141.0830079-.4130859.0830079z"
              fill="#e7e7e7"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m5.4298782 18.7308922h-1.6814134v20.9468765c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468765z"
              fill="#d5d3d4"
            ></path>
          </g>
          <g>
            <path
              d="m30.9857845 27.1586342v.0000229c0 7.2873306-5.9075508 13.1948814-13.1948833 13.1948814h-9.6740799c-1.9780579 0-2.6746974 2.6099319-.965611 3.605793 4.1490302 2.4175835 11.7045918 4.035305 20.3480434 4.035305 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468765h-11.8365168c-4.6545143 0-8.4277439 3.7732296-8.4277439 8.427742z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m5.4298782 15.3222141h-1.6814134v20.9468784c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784z"
              fill="#63affa"
            ></path>
          </g>
          <g>
            <path
              d="m30.9857845 23.7499561v.0000229c0 7.2873325-5.9075508 13.1948833-13.1948833 13.1948833h-9.6740799c-1.9780579 0-2.6746974 2.6099319-.965611 3.605793 4.1490302 2.4175797 11.7045918 4.035305 20.3480434 4.035305 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784h-11.8365168c-4.6545143 0-8.4277439 3.7732296-8.4277439 8.427742z"
              fill="#529ffb"
            ></path>
          </g>
          <g>
            <path
              d="m5.4298782 15.3222141h-1.6814134v20.9468784c0 4.5932426 10.633543 8.3168678 23.7507896 8.3168678 13.1171665 0 23.7507915-3.7236252 23.7507915-8.3168678v-20.9468784z"
              fill="#63affa"
            ></path>
          </g>
          <g>
            <path
              d="m51.2515717 15.3186769v20.9500122c0 4.5899658-10.6400146 8.3200073-23.7500019 8.3200073-8.6499634 0-16.2000122-1.6199951-20.3499756-4.0400391-1.710022-.9899902-1.0100098-3.5999756.9699702-3.5999756h9.6700439c.2299805 0 .4699707-.0100098.6999512-.0200195.8699951-.039978 1.7200317-.1699829 2.5400391-.3899536 4.2099609-1.0500488 7.6099854-4.1400146 9.1099854-8.1600342.5499878-1.4400024.8400269-3 .8400269-4.6300049 0-4.6499634 3.7799702-8.4299917 8.4299946-8.4299917h11.8399662z"
              fill="#529ffb"
            ></path>
          </g>
          <g>
            <ellipse cx="27.499" cy="15.322" fill="#e7e7e7" rx="23.751" ry="8.317"></ellipse>
          </g>
          <g>
            <ellipse cx="27.499" cy="15.322" fill="#d5d3d4" rx="22.069" ry="7.108"></ellipse>
          </g>
          <g>
            <path
              d="m39.3425179 12.5343056v.0000086c0 2.8541832-2.3137741 5.1679564-5.1679573 5.1679564h-27.4499183c3.0420556 2.7534161 11.1819878 4.72822 20.7746124 4.72822 12.1885166 0 22.0692959-3.1825085 22.0692959-7.1082764 0-2.0489769-2.6993256-3.891921-7.0088234-5.1878338-1.5995336-.4809981-3.2172093.7296342-3.2172093 2.3999252z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m42.6123238 39.6935921c-.2304688-.6416016.1035156-1.3486328.7460747-1.578125 2.3174019-.8300781 3.8154488-2.0039063 3.8154488-2.9892578 0-.6816406.5527344-1.234375 1.234375-1.234375s1.234375.5527344 1.234375 1.234375c0 2.1669922-1.9355469 4.0546875-5.4521484 5.3134766-.6268426.2283515-1.3442537-.0925256-1.5781251-.7460938z"
              fill="#82c8fb"
            ></path>
          </g>
          <g>
            <path
              d="m10.6738482 14.1789427c-.4140625 0-.8076172-.2441406-.9794922-.6494141-.2275391-.5410156.0263672-1.1640625.5664063-1.3925781 2.0585938-.8671875 4.5800781-1.5703125 7.2919931-2.0332031.5859375-.09375 1.1269531.2919922 1.2265625.8691406.0986328.5791016-.2910156 1.1279297-.8691406 1.2265625-3.2265635.5498047-5.4912119 1.3349609-6.8232431 1.8964844-.1347657.0566406-.2753907.0830078-.413086.0830078z"
              fill="#e7e7e7"
            ></path>
          </g>
        </g>
        <g>
          <path
            d="m28.5097237 14.2241135h-3.8925285c-1.1638851 0-1.9982204-.9269915-1.6626205-1.8472576l.8536015-2.3406925c.2209091-.6057634.8964939-1.0203838 1.6626205-1.0203838h2.1853275c.7661247 0 1.4417095.4146204 1.6626186 1.0203838l.8536015 2.3406925c.3356017.9202661-.4987355 1.8472576-1.6626206 1.8472576z"
            fill="#d5d3d4"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m30.1669559 16.0053635h-4.6602669c-1.3934422 0-2.3923378-1.1098251-1.9905434-2.2115984l1.0219593-2.8023548c.2644806-.7252407 1.0733128-1.2216377 1.9905434-1.2216377h2.6163464c.9172325 0 1.7260647.496397 1.9905453 1.2216377l1.0219574 2.8023548c.4017944 1.1017732-.5971012 2.2115984-1.9905415 2.2115984z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m29.4917507 15.2513704h-4.6602669c-1.3934402 0-2.3923359-1.1098251-1.9905434-2.2115984l1.0219593-2.8023548c.2644806-.7252407 1.0733128-1.2216377 1.9905453-1.2216377h2.6163464c.9172306 0 1.7260628.496397 1.9905434 1.2216377l1.0219593 2.8023548c.4017944 1.1017733-.5971012 2.2115984-1.9905434 2.2115984z"
              fill="#e7e7e7"
            ></path>
          </g>
          <g>
            <path
              d="m28.3179779 14.5736446h-2.3127193c-.691515 0-1.1872292-.3882561-.9878349-.773695l.5071621-.9803619c.1312504-.2537155.5326443-.427372.987833-.427372h1.2983971c.4551888 0 .8565826.1736565.9878349.427372l.5071602.9803619c.1993961.385439-.29632.773695-.9878331.773695z"
              fill="#c4c4c4"
            ></path>
          </g>
          <g>
            <path
              d="m28.1451321 11.6468515h-1.3960571c-.417429 0-.7166634-.2805548-.5963001-.5590734l.3061447-.7084112c.0792294-.1833344.3215275-.3088198.5963001-.3088198h.7837677c.2747726 0 .5170708.1254854.5963001.3088198l.3061447.7084112c.1203632.2785187-.1788712.5590734-.5963001.5590734z"
              fill="#c4c4c4"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m40.5380249 33.0965958c.4474564.3805428.4474564 1.0647163 0 1.4452553-1.7446747 1.4837646-4.7070465 4.7357063-9.875803 4.7357063s-11.0331306-3.2519417-12.7778072-4.7357063c-.4474564-.3805389-.4474564-1.0647125 0-1.4452553 1.7446766-1.4837608 7.6090488-4.7357044 12.7778072-4.7357044s8.1311283 3.2519435 9.875803 4.7357044z"
              fill="#e7e7e7"
            ></path>
          </g>
          <g>
            <path
              d="m15.4195747 30.1476555v7.3431396c0 .8847618 1.1128788 1.3278542 1.7637444.7022324l3.8197155-3.6715698c.4034805-.3878326.4034805-1.0166321 0-1.4044647l-3.8197155-3.6715698c-.6508656-.6256219-1.7637444-.1825314-1.7637444.7022323z"
              fill="#e7e7e7"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m40.5416107 34.5387077c-1.75 1.4899902-4.710022 4.7399902-9.8800068 4.7399902-3.3600464 0-7.0100098-1.3699951-9.6300049-2.7399902 4.2099609-1.0500488 7.6099854-4.1400146 9.1099854-8.1600342.1799927-.0200195.3499756-.0200195.5200195-.0200195 5.1699848 0 8.1300068 3.25 9.8800068 4.7400513.4400025.3800049.4400025 1.0599976 0 1.4400024z"
              fill="#d5d3d4"
            ></path>
          </g>
          <g>
            <path
              d="m17.7916088 36.9486809c.2299805 0 .4699707-.0100098.6999512-.0200195l-1.3099976 1.2600098c-.6499634.6300049-1.7599487.1900024-1.7599487-.7000122v-.539978h2.3699951z"
              fill="#d5d3d4"
            ></path>
          </g>
        </g>
        <g>
          <path
            d="m36.4124184 33.3627663c0 .5407753-.4383888.9791641-.9791679.9791641s-.9791832-.4383888-.9791832-.9791641c0-.5407791.4384041-.9791679.9791832-.9791679s.9791679.4383888.9791679.9791679z"
            fill="#626681"
          ></path>
        </g>
      </g>
    </svg>
  ),

  // Common extra
  sugar: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <path
              d="m248.214 141.659-120.357-60.178 120.357-60.179 120.357 60.179z"
              fill="#e4f6ff"
            ></path>
          </g>
          <g>
            <path
              d="m248.214 21.302-18.376 9.188 84.757 42.378c7.097 3.548 7.097 13.676 0 17.224l-84.757 42.378 18.376 9.188 120.357-60.178z"
              fill="#d3effb"
            ></path>
          </g>
          <g>
            <path d="m127.857 81.481 120.357 60.178v144.428l-120.357-60.178z" fill="#b1e4f9"></path>
          </g>
          <g>
            <path d="m368.571 81.481-120.357 60.178v144.428l120.357-60.178z" fill="#90d8f9"></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m127.857 346.266-120.357-60.179 120.357-60.178 120.357 60.178z"
              fill="#e4f6ff"
            ></path>
          </g>
          <g>
            <path
              d="m127.857 225.909-18.376 9.188 84.757 42.378c7.097 3.548 7.097 13.676 0 17.224l-84.757 42.379 18.376 9.188 120.357-60.178z"
              fill="#d3effb"
            ></path>
          </g>
          <g>
            <path d="m7.5 286.087 120.357 60.179v144.428l-120.357-60.178z" fill="#b1e4f9"></path>
          </g>
          <g>
            <path d="m248.214 286.087-120.357 60.179v144.428l120.357-60.178z" fill="#90d8f9"></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m369.984 343.947-83.559-105.475 134.516-3.562 83.559 105.475z"
              fill="#e4f6ff"
            ></path>
          </g>
          <g>
            <path
              d="m420.941 234.91-20.538.544 58.843 74.277c4.927 6.219.639 15.394-7.292 15.604l-94.728 2.508 12.758 16.104 134.516-3.562z"
              fill="#d3effb"
            ></path>
          </g>
          <g>
            <path
              d="m286.425 238.472 83.559 105.475-61.148 130.845-83.559-105.475z"
              fill="#b1e4f9"
            ></path>
          </g>
          <g>
            <path
              d="m504.5 340.385-134.516 3.562-61.148 130.845 134.516-3.562z"
              fill="#90d8f9"
            ></path>
          </g>
        </g>
        <g>
          <path d="m510.379 335.728-83.56-105.476c-1.466-1.849-3.688-2.925-6.077-2.84l-45.192 1.197c.329-.849.52-1.758.52-2.701v-144.413c0-.005.001-.009.001-.014 0-2.841-1.605-5.438-4.146-6.708l-60.075-30.037c-3.707-1.855-8.211-.351-10.062 3.354-1.853 3.705-.351 8.21 3.354 10.062l46.659 23.329-103.587 51.793-103.587-51.793 103.586-51.793 25.547 12.772c3.707 1.855 8.211.351 10.062-3.354 1.853-3.705.351-8.21-3.354-10.062l-28.901-14.45c-2.111-1.057-4.597-1.057-6.708 0l-120.356 60.179c-2.541 1.271-4.146 3.867-4.146 6.708 0 .014.003.028.003.042v139.75l-116.214 58.106c-2.541 1.271-4.146 3.867-4.146 6.708v.001 41.78c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-29.646l105.357 52.679v127.66l-105.357-52.678v-62.938c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v67.573c0 2.841 1.605 5.438 4.146 6.708l120.36 60.181c1.056.528 2.205.792 3.354.792s2.299-.264 3.354-.792l120.35-60.181c2.541-1.271 4.146-3.867 4.146-6.708v-10.708l47.247 59.639c1.425 1.799 3.592 2.843 5.879 2.843.065 0 .132-.001.198-.003l134.516-3.562c2.84-.075 5.394-1.748 6.597-4.321l18.07-38.666c1.753-3.753.133-8.217-3.619-9.971-3.754-1.752-8.217-.134-9.971 3.619l-16.107 34.467-117.75 3.118 54.048-115.652 117.75-3.118-23.087 49.402c-1.753 3.753-.133 8.217 3.619 9.971 1.027.479 2.107.707 3.171.707 2.822 0 5.525-1.602 6.8-4.326l28.225-60.396c1.201-2.574.847-5.607-.917-7.833zm-149.309-242.112v127.657l-16.295 8.151-58.549 1.551c-.018 0-.029.006-.046.007-2.732.091-5.314 1.669-6.551 4.314l-16.28 34.837-7.636 3.818v-127.657zm-120.356 52.678v127.658l-105.354-52.678v-127.657zm-112.857 88 103.584 51.794-103.584 51.793-103.586-51.794zm112.853 191.589-105.353 52.681v-127.663l105.353-52.677v20.353l-22.228 47.564c-1.203 2.574-.848 5.606.916 7.833l21.312 26.902zm66.469 34.74-73.145-92.331 54.048-115.651 73.145 92.33zm66.355-124.272-71.916-90.778 115.772-3.066 71.916 90.778z"></path>
          <circle cx="334.793" cy="192.358" r="8.081"></circle>
          <circle cx="334.793" cy="161.043" r="8.081"></circle>
          <circle cx="303.478" cy="203.47" r="8.081"></circle>
        </g>
      </g>
    </svg>
  ),
  can: (props) => (
    <svg viewBox="0 0 511.998 511.998" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="m65.175 496.976h381.648v-99.985l-20.001-20h-341.646l-20.001 20z"
          fill="#ff1f3d"
        ></path>
        <path d="m446.823 496.976v-99.985l-20.001-20h-170.823v119.985z" fill="#e20059"></path>
        <path d="m65.175 15.022v99.985l20.001 20h341.646l20.001-20v-99.985z" fill="#ff1f3d"></path>
        <path d="m446.823 115.007v-99.985h-190.824v119.985h170.823z" fill="#e20059"></path>
        <g>
          <path d="m47.173 481.998h417.653v30h-417.653z" fill="#fff5f5"></path>
        </g>
        <g>
          <path d="m47.173 0h417.653v30h-417.653z" fill="#fff5f5"></path>
        </g>
        <path d="m65.175 115.007h381.648v281.983h-381.648z" fill="#fff5f5"></path>
        <path d="m255.999 115.007h190.824v281.983h-190.824z" fill="#ece6f2"></path>
        <g>
          <path d="m240.999 171h30v39.308h-30z" fill="#00da80"></path>
        </g>
        <path d="m255.999 171h15v39.308h-15z" fill="#00a78e"></path>
        <path
          d="m295.816 187.371c-9.613 0-19.004 1.832-27.909 5.443l-.816.331c-7.081 2.87-15.104 2.87-22.181 0l-.815-.331c-8.908-3.612-18.299-5.443-27.911-5.443-38.503 0-69.827 31.325-69.827 69.828 0 47.106 38.324 85.43 85.43 85.43h48.426c47.106 0 85.431-38.324 85.431-85.431-.001-38.503-31.325-69.827-69.828-69.827z"
          fill="#ff1f3d"
        ></path>
        <path d="m255.999 481.998h208.826v30h-208.826z" fill="#ece6f2"></path>
        <path d="m255.999 0h208.826v30h-208.826z" fill="#ece6f2"></path>
        <path
          d="m295.816 187.371c-9.613 0-19.004 1.832-27.909 5.443l-.816.331c-3.54 1.435-7.316 2.152-11.091 2.153v147.331h24.213c47.106 0 85.431-38.324 85.431-85.431-.001-38.503-31.325-69.827-69.828-69.827z"
          fill="#e20059"
        ></path>
      </g>
    </svg>
  ),
  can2: (props) => (
    <svg
      enable-background="new 0 0 497 497"
      viewBox="0 0 497 497"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="m308.5 437v60h30c16.569 0 30-13.431 30-30z" fill="#9abbd0"></path>
        <path
          d="m338.5 467-90-30-120 30c0 16.569 13.431 30 30 30h150c16.569 0 30-13.431 30-30z"
          fill="#acd5df"
        ></path>
        <path d="m338.5 407v60h30c16.569 0 30-13.431 30-30z" fill="#acd5df"></path>
        <path
          d="m368.5 437-120-30-150 30c0 16.569 13.431 30 30 30h210c16.569 0 30-13.431 30-30z"
          fill="#c4f3ff"
        ></path>
        <path
          d="m391.39 65.737-32.498-50.737h-20.392v105l60-30c0-8.938-2.617-17.26-7.11-24.263z"
          fill="#61ce5a"
        ></path>
        <path
          d="m361.39 65.737-32.498-50.737h-190.784l-32.498 50.737c-4.493 7.003-7.11 15.325-7.11 24.263l150 30 120-30c0-8.938-2.617-17.26-7.11-24.263z"
          fill="#94e368"
        ></path>
        <path d="m368.5 90-30 257 60-137v-120z" fill="#2db94d"></path>
        <path d="m98.5 90v227l270 30v-257z" fill="#61ce5a"></path>
        <path
          d="m368.5 437h30v-227c-10.74 0-20.688.565-30 1.583l-60 112.708z"
          fill="#61ce5a"
        ></path>
        <path
          d="m98.5 317v120h270v-225.417c-120.746 13.207-130.74 105.417-270 105.417z"
          fill="#94e368"
        ></path>
        <path d="m368.5 0h-30v30h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" fill="#acd5df"></path>
        <path
          d="m353.5 15c0-8.284-6.716-15-15-15h-210c-8.284 0-15 6.716-15 15s6.716 15 15 15h210c8.284 0 15-6.716 15-15z"
          fill="#c4f3ff"
        ></path>
      </g>
    </svg>
  ),
  jar1: (props) => (
    <svg viewBox="-24 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m445.195312 159.339844-48.417968-60.242188h-338.582032l-40.164062 60.242188c-16.519531 24.78125-22.003906 55.3125-15.140625 84.292968l57.539063 242.949219c3.53125 14.898438 16.835937 25.417969 32.144531 25.417969h278.078125c15.308594 0 28.613281-10.519531 32.144531-25.417969l57.539063-242.949219c6.863281-28.980468 1.378906-59.511718-15.140626-84.292968zm0 0"
        fill="#f9eac7"
      ></path>
      <path
        d="m445.195312 159.339844-48.417968-60.242188h-338.582032l-40.164062 60.242188c-16.519531 24.78125-22.003906 55.3125-15.140625 84.292968l57.542969 242.949219c3.527344 14.898438 16.832031 25.417969 32.140625 25.417969h50.707031l-33.992188-268.367188c-2.191406-17.300781-2.007812-35.140624.367188-51.988281.964844-6.847656 4.917969-12.882812 10.792969-16.527343.027343-.019532.054687-.035157.082031-.050782 9.261719-5.75 15.949219-9.90625 31.191406-9.90625 15.25 0 21.945313 4.15625 31.207032 9.90625 10.675781 6.625 23.960937 14.871094 48.628906 14.871094 24.660156 0 37.945312-8.246094 48.617187-14.871094 9.257813-5.75 15.949219-9.90625 31.191407-9.90625 15.257812 0 21.957031 4.15625 31.226562 9.90625 10.675781 6.625 23.964844 14.871094 48.640625 14.871094 24.671875 0 37.960937-8.246094 48.636719-14.871094 3.886718-2.410156 7.308594-4.453125 11.039062-6.089844-1.730468-3.292968-3.632812-6.511718-5.714844-9.636718zm0 0"
        fill="#f4dbb3"
      ></path>
      <path
        d="m88.664062 478.96875h285.898438c7.65625 0 14.308594-5.261719 16.074219-12.710938l53.628906-226.433593c5.730469-24.203125 1.203125-49.941407-12.425781-70.734375l-42.980469-53.476563h-321.824219l-35.261718 52.890625c-13.980469 20.964844-18.617188 46.800782-12.8125 71.320313l53.628906 226.433593c1.765625 7.449219 8.417968 12.710938 16.074218 12.710938zm0 0"
        fill="#ffc269"
      ></path>
      <path
        d="m436.527344 177.117188c-1.417969-2.746094-2.980469-5.425782-4.6875-8.027344l-42.980469-53.476563h-321.824219l-35.261718 52.890625c-13.980469 20.96875-18.617188 46.800782-12.8125 71.320313l53.628906 226.433593c1.765625 7.449219 8.417968 12.710938 16.074218 12.710938h50.433594l-29.808594-235.335938c-2.191406-17.300781-2.007812-35.140624.367188-51.988281.964844-6.847656 4.917969-12.882812 10.792969-16.53125.027343-.015625.054687-.03125.082031-.050781 9.261719-5.746094 15.949219-9.902344 31.191406-9.902344 15.25 0 21.945313 4.15625 31.207032 9.90625 10.675781 6.625 23.960937 14.867188 48.628906 14.867188 24.660156 0 37.945312-8.246094 48.617187-14.871094 9.257813-5.746094 15.949219-9.902344 31.191407-9.902344 15.257812 0 21.957031 4.15625 31.226562 9.90625 10.675781 6.625 23.964844 14.867188 48.640625 14.867188 22.183594 0 35.140625-6.65625 45.292969-12.816406zm0 0"
        fill="#ffa95f"
      ></path>
      <path
        d="m405.03125 0h-346.835938c-9.121093 0-16.515624 7.394531-16.515624 16.515625v33.03125c0 9.121094 7.394531 16.515625 16.515624 16.515625h346.839844c9.121094 0 16.515625-7.394531 16.515625-16.515625v-33.03125c-.003906-9.121094-7.394531-16.515625-16.519531-16.515625zm0 0"
        fill="#ff8b5a"
      ></path>
      <path
        d="m458.878906 136.425781c4.648438 4.648438 2.214844 12.457031-4.199218 13.917969-24.535157 5.589844-29.898438 23.074219-63.445313 23.074219-39.933594 0-39.933594-24.773438-79.867187-24.773438-39.90625 0-39.90625 24.773438-79.808594 24.773438-39.917969 0-39.917969-24.773438-79.835938-24.773438-39.902344 0-39.902344 24.773438-79.808594 24.773438-33.507812 0-38.871093-17.480469-63.375-23.074219-6.410156-1.460938-8.84375-9.265625-4.195312-13.914062l30.078125-30.078126c4.644531-4.644531 10.945313-7.253906 17.515625-7.253906h359.347656c6.570313 0 12.871094 2.609375 17.519532 7.253906zm0 0"
        fill="#ff8b5a"
      ></path>
      <path
        d="m302.207031 90.839844h-18.117187l12.257812 27.140625c1.378906 3.050781 4.378906 4.859375 7.53125 4.859375 1.128906 0 2.289063-.234375 3.386719-.734375 4.160156-1.875 6.007813-6.765625 4.128906-10.921875zm0 0"
        fill="#ff7350"
      ></path>
      <path
        d="m159.195312 99.097656h-107.253906c-6.570312 0-12.871094 2.609375-17.519531 7.253906l-30.078125 30.078126c-4.648438 4.648437-2.214844 12.453124 4.195312 13.914062 24.503907 5.59375 29.867188 23.078125 63.378907 23.078125 35.445312 0 39.464843-19.511719 67.875-23.878906zm0 0"
        fill="#ff7350"
      ></path>
      <path
        d="m109.5625 90.839844-21.265625 34.929687c-2.371094 3.894531-1.136719 8.976563 2.769531 11.347657 1.335938.820312 2.820313 1.207031 4.28125 1.207031 2.789063 0 5.507813-1.414063 7.0625-3.964844l26.492188-43.519531zm0 0"
        fill="#ff8b5a"
      ></path>
      <path
        d="m132.515625 24.773438v-24.773438h-74.320313c-9.121093 0-16.515624 7.394531-16.515624 16.515625v33.03125c0 9.125 7.394531 16.515625 16.515624 16.515625h346.839844c9.121094 0 16.515625-7.394531 16.515625-16.515625h-264.261719c-13.679687 0-24.773437-11.089844-24.773437-24.773437zm0 0"
        fill="#ff7350"
      ></path>
      <path
        d="m396.773438 99.097656h-330.320313c-9.121094 0-16.515625-7.394531-16.515625-16.515625 0-9.121093 7.394531-16.515625 16.515625-16.515625h330.324219c9.121094 0 16.515625 7.394532 16.515625 16.515625-.003907 9.121094-7.398438 16.515625-16.519531 16.515625zm0 0"
        fill="#9f6e50"
      ></path>
      <path
        d="m396.773438 66.066406h-264.257813c-4.558594 0-8.257813 3.695313-8.257813 8.257813 0 4.558593 3.699219 8.257812 8.257813 8.257812h280.773437c0-9.121093-7.394531-16.515625-16.515624-16.515625zm0 0"
        fill="#b57f5f"
      ></path>
    </svg>
  ),

  vegetables: (props) => (
    <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="_28-ingredients" data-name="28-ingredients">
        <path
          d="m35 35a9 9 0 0 0 -8-8.942c0-.019 0-9.058-9-9.058s-9 9.039-9 9.058a8.989 8.989 0 0 0 -4.938 15.7 8.991 8.991 0 0 0 4.96 12.732 8.987 8.987 0 0 0 17.95 0 8.991 8.991 0 0 0 4.96-12.732 8.97 8.97 0 0 0 3.068-6.758z"
          fill="#95c590"
        ></path>
        <path
          d="m46 51c0 6.627-3.134 12-7 12s-6-5.373-6-12 3.134-12 7-12 6 5.373 6 12z"
          fill="#f0dc62"
        ></path>
        <path
          d="m29 51c0 6.627-2.134 12-6 12s-7-5.373-7-12 2.134-12 6-12 7 5.373 7 12z"
          fill="#f0dc62"
        ></path>
        <path d="m29 41-1-10h6l-1 10z" fill="#81b87b"></path>
        <path
          d="m39 48c0 8.284-3.029 15-8 15s-8-6.716-8-15 3.029-11 8-11 8 2.716 8 11z"
          fill="#fcea81"
        ></path>
        <path
          d="m23.781 31.375a1 1 0 0 0 -1.406-.156l-3.375 2.7v-7.919a1 1 0 0 0 -2 0v7.919l-3.375-2.7a1 1 0 0 0 -1.25 1.562l4.625 3.7v1.519a1 1 0 0 0 2 0v-1.519l4.625-3.7a1 1 0 0 0 .156-1.406z"
          fill="#81b87b"
        ></path>
        <path
          d="m13.625 39.219a1 1 0 0 0 -1.25 1.562l2 1.6a1 1 0 0 0 1.25-1.563z"
          fill="#81b87b"
        ></path>
        <path d="m47 19s-5-9-12-13l6-3s7 8 8 16z" fill="#81b87b"></path>
        <path d="m51 19s5-9 12-13l-6-3s-7 8-8 16z" fill="#81b87b"></path>
        <path d="m51 19h-4l-1-18h6z" fill="#95c590"></path>
        <path
          d="m59 25c0 5.523-4.477 38-10 38s-10-32.477-10-38 4.477-8 10-8 10 2.477 10 8z"
          fill="#f59760"
        ></path>
        <g fill="#e07f45">
          <path d="m51 39v2h6.029q.175-1.01.336-2z"></path>
          <path d="m54.959 51h-4.959v2h4.434c.179-.651.354-1.315.525-2z"></path>
          <path d="m53 27v2h5.719c.075-.739.136-1.409.181-2z"></path>
          <path d="m40.025 35h5.975v-2h-6.248q.126.969.273 2z"></path>
          <path d="m46 45h-4.285q.2 1.007.41 2h3.875z"></path>
          <path d="m40.031 21a6.957 6.957 0 0 0 -.808 2h4.777v-2z"></path>
        </g>
      </g>
    </svg>
  ),
  fruits: (props) => (
    <svg viewBox="-4 0 512 512.00065" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m475.894531 83.761719c-2.617187-8.214844-7.289062-14.644531-13.101562-19.253907-3.589844-2.851562-5.625-7.230468-5.625-11.816406v-37.453125c0-4.207031-3.410157-7.617187-7.617188-7.617187h-15.234375c-4.203125 0-7.613281 3.410156-7.613281 7.617187v31.765625c0 5.625-3.082031 10.832032-8.070313 13.433594-7.175781 3.75-13.386718 9.8125-17.425781 18.265625-17.023437 35.660156-47.238281 109.488281-109.300781 171.429687-61.941406 62.0625-135.773438 92.277344-171.429688 109.304688-32.660156 15.59375-29.777343 63.585938 5.054688 74.683594 20.34375 6.480468 42.945312 9.589844 66.605469 9.160156 69.027343-1.246094 141.632812-39.960938 197.296875-95.621094 55.660156-55.660156 94.375-128.265625 95.621094-197.296875.429687-23.660156-2.679688-46.257812-9.160157-66.601562zm0 0"
        fill="#ffcf5d"
      ></path>
      <path
        d="m443.859375 88.375c1.378906 1.09375 2.359375 2.605469 3.003906 4.632812 5.5 17.261719 8.101563 36.371094 7.730469 56.808594-1.03125 57.136719-33.445312 123.042969-86.703125 176.304688-53.261719 53.257812-119.167969 85.667968-176.308594 86.703125-16.144531.292969-29.121093 13.09375-29.871093 28.996093 9.871093 1.160157 20.046874 1.652344 30.425781 1.464844 69.027343-1.25 141.632812-39.964844 197.296875-95.625 55.660156-55.660156 94.375-128.265625 95.621094-197.296875.429687-23.65625-2.679688-46.257812-9.160157-66.601562-2.617187-8.214844-7.289062-14.644531-13.101562-19.253907-3.589844-2.851562-5.625-7.230468-5.625-11.816406v-37.453125c0-4.207031-3.410157-7.617187-7.617188-7.617187h-15.234375c-4.203125 0-7.613281 3.410156-7.613281 7.617187v37.453125c0 14.027344 6.253906 27.035156 17.15625 35.683594zm0 0"
        fill="#ffb545"
      ></path>
      <path
        d="m89.472656 230.800781-25.617187-16.222656c-6.441407-4.078125-14.542969 1.992187-12.3125 9.238281l7.519531 24.414063c5.601562 18.203125 17.199219 34.023437 32.941406 44.945312l25.171875 16.5625c0-29.660156-1.148437-62.121093-27.703125-78.9375zm0 0"
        fill="#28d05b"
      ></path>
      <path
        d="m204.679688 227.238281-4.0625-4.0625c-2.039063-2.039062-5.054688-2.75-7.792969-1.839843-39.664063 13.222656-68.964844 43.359374-84.730469 87.15625l14.332031 5.160156c13.730469-38.148438 37.542969-63.796875 70.816407-76.304688l.664062.664063c2.976562 2.972656 7.796875 2.972656 10.769531 0 2.976563-2.976563 2.976563-7.796875.003907-10.773438zm0 0"
        fill="#b66652"
      ></path>
      <path
        d="m159.308594 298.679688c-14.769532-.539063-29.082032 3.308593-42.132813 10.589843-13.050781-7.28125-27.363281-11.132812-42.132812-10.589843-30.878907 1.316406-53.089844 17.878906-64.933594 39.203124-11.890625 21.671876-13.410156 48.109376-3.929687 77.28125 14.5 44.488282 52.976562 84.335938 89.53125 86.425782 3.589843.242187 7.101562.171875 10.515624-.191406 7.230469-.761719 14.667969-.761719 21.894532 0 3.414062.363281 6.925781.433593 10.515625.191406 36.554687-2.089844 75.035156-41.9375 89.535156-86.425782 9.480469-29.171874 7.957031-55.609374-3.929687-77.28125-11.84375-21.324218-34.054688-37.886718-64.933594-39.203124zm0 0"
        fill="#ff5368"
      ></path>
      <path
        d="m224.242188 337.882812c-5.796876-10.4375-14.082032-19.726562-24.648438-26.652343 1.105469 1.671875 2.148438 3.378906 3.117188 5.121093 11.886718 21.671876 13.410156 48.109376 3.929687 77.285157-9.738281 29.867187-30.285156 57.648437-53.800781 73.308593-12.984375 8.652344-28.3125 13.113282-43.917969 13.113282h-59.964844c14.519531 12.523437 30.820313 20.621094 46.757813 21.53125 3.589844.246094 7.101562.171875 10.515625-.191406 7.28125-.769532 14.625-.765626 21.902343.003906 3.414063.359375 6.921876.429687 10.507813.1875 36.550781-2.085938 75.035156-41.9375 89.53125-86.421875 9.480469-29.175781 7.957031-55.609375-3.929687-77.285157zm0 0"
        fill="#d9435b"
      ></path>
      <path
        d="m432.785156 313.292969c-3.203125-13.398438-15.246094-23.359375-29.625-23.359375-14.375 0-26.417968 9.960937-29.621094 23.359375-41.636718 12.675781-71.929687 51.375-71.929687 97.15625 0 56.085937 45.464844 101.550781 101.550781 101.550781 56.085938 0 101.550782-45.464844 101.550782-101.550781 0-45.78125-30.292969-84.480469-71.925782-97.15625zm0 0"
        fill="#ff983b"
      ></path>
      <path
        d="m463.390625 328.683594c12.433594 16.851562 19.789063 37.683594 19.789063 60.234375 0 56.085937-45.46875 101.550781-101.550782 101.550781-22.550781 0-43.378906-7.355469-60.230468-19.789062 18.492187 25.0625 48.226562 41.320312 81.761718 41.320312 56.085938 0 101.550782-45.464844 101.550782-101.550781 0-33.535157-16.257813-63.269531-41.320313-81.765625zm0 0"
        fill="#ff7e40"
      ></path>
      <path
        d="m395.542969 249.269531v70.8125c0 4.167969 3.214843 7.804688 7.382812 7.929688 4.3125.132812 7.851563-3.328125 7.851563-7.613281v-79.34375c-6.539063-4.296876-15.234375.390624-15.234375 8.214843zm0 0"
        fill="#b66652"
      ></path>
      <path
        d="m461.175781 316.957031-7.515625-24.414062c-5.605468-18.203125-17.203125-34.027344-32.941406-44.945313l-9.941406-6.539062c-6.539063-4.300782-15.234375.386718-15.234375 8.210937v10.820313c0 20.367187 9.742187 38.511718 27.703125 49.882812l25.621094 16.226563c6.4375 4.074219 14.539062-2 12.308593-9.242188zm0 0"
        fill="#28d05b"
      ></path>
      <path
        d="m363.738281 360.003906c0 4.207032-3.40625 7.617188-7.613281 7.617188s-7.617188-3.410156-7.617188-7.617188c0-4.207031 3.410157-7.617187 7.617188-7.617187s7.613281 3.410156 7.613281 7.617187zm0 0"
        fill="#ff7e40"
      ></path>
      <path
        d="m384.050781 388.441406c0 4.207032-3.40625 7.617188-7.613281 7.617188s-7.617188-3.410156-7.617188-7.617188c0-4.207031 3.410157-7.617187 7.617188-7.617187s7.613281 3.410156 7.613281 7.617187zm0 0"
        fill="#ff7e40"
      ></path>
      <path
        d="m343.429688 410.785156c0 4.207032-3.410157 7.613282-7.617188 7.613282s-7.617188-3.40625-7.617188-7.613282c0-4.207031 3.410157-7.617187 7.617188-7.617187s7.617188 3.410156 7.617188 7.617187zm0 0"
        fill="#ff7e40"
      ></path>
      <path
        d="m292.148438 28.101562c-1.609376-3.886718-6.066407-5.730468-9.953126-4.121093l-4.5625 1.886719 3.492188-3.492188c2.976562-2.972656 2.976562-7.796875 0-10.769531-2.972656-2.972657-7.796875-2.972657-10.769531 0l-3.492188 3.492187 1.890625-4.5625c1.609375-3.886718-.238281-8.34375-4.125-9.953125-3.882812-1.613281-8.339844.234375-9.949218 4.125l-4.136719 9.984375 27.5 27.496094 9.984375-4.136719c3.882812-1.609375 5.730468-6.0625 4.121094-9.949219zm0 0"
        fill="#28d05b"
      ></path>
      <path
        d="m212.59375 22.6875c15.863281-15.863281 39.429688-13.707031 55.292969 2.15625s18.015625 39.429688 2.152343 55.292969c-15.863281 15.863281-58.097656 32.378906-73.960937 16.515625-15.863281-15.863282.652344-58.097656 16.515625-73.964844zm0 0"
        fill="#ff5368"
      ></path>
      <path
        d="m267.886719 24.84375c-3.808594-3.808594-8.0625-6.816406-12.546875-8.988281 6.863281 14.191406 5.222656 30.691406-6.832032 42.746093-12.054687 12.058594-39.332031 24.472657-58.699218 22.785157.535156 6.117187 2.460937 11.457031 6.269531 15.265625 15.863281 15.863281 58.097656-.652344 73.960937-16.515625 15.867188-15.863281 13.710938-39.429688-2.152343-55.292969zm0 0"
        fill="#d9435b"
      ></path>
      <g fill="#ffcf5d">
        <path d="m243.144531 57.203125c0 4.203125-3.410156 7.613281-7.617187 7.613281-4.203125 0-7.613282-3.410156-7.613282-7.613281 0-4.207031 3.410157-7.617187 7.613282-7.617187 4.207031 0 7.617187 3.410156 7.617187 7.617187zm0 0"></path>
        <path d="m221.601562 78.742188c0 4.207031-3.410156 7.617187-7.613281 7.617187-4.207031 0-7.617187-3.410156-7.617187-7.617187 0-4.203126 3.410156-7.613282 7.617187-7.613282 4.203125 0 7.613281 3.410156 7.613281 7.613282zm0 0"></path>
        <path d="m221.601562 57.203125c0 4.203125-3.410156 7.613281-7.613281 7.613281-4.207031 0-7.617187-3.410156-7.617187-7.613281 0-4.207031 3.410156-7.617187 7.617187-7.617187 4.203125 0 7.613281 3.410156 7.613281 7.617187zm0 0"></path>
        <path d="m243.144531 78.742188c0 4.207031-3.410156 7.617187-7.617187 7.617187-4.203125 0-7.613282-3.410156-7.613282-7.617187 0-4.203126 3.410157-7.613282 7.613282-7.613282 4.207031 0 7.617187 3.410156 7.617187 7.613282zm0 0"></path>
        <path d="m264.6875 57.203125c0 4.203125-3.410156 7.613281-7.617188 7.613281-4.207031 0-7.617187-3.410156-7.617187-7.613281 0-4.207031 3.410156-7.617187 7.617187-7.617187 4.207032 0 7.617188 3.410156 7.617188 7.617187zm0 0"></path>
        <path d="m243.144531 35.660156c0 4.203125-3.410156 7.613282-7.617187 7.613282-4.203125 0-7.613282-3.410157-7.613282-7.613282 0-4.207031 3.410157-7.617187 7.613282-7.617187 4.207031 0 7.617187 3.410156 7.617187 7.617187zm0 0"></path>
      </g>
      <path
        d="m187.363281 156.144531c0 28.042969-22.734375 50.773438-50.777343 50.773438-28.042969 0-50.773438-22.730469-50.773438-50.773438s22.730469-50.777343 50.773438-50.777343c28.042968 0 50.777343 22.734374 50.777343 50.777343zm0 0"
        fill="#5c87bd"
      ></path>
      <path
        d="m160.070312 111.128906c3.671876 7.023438 5.761719 15.007813 5.761719 23.484375 0 28.039063-22.734375 50.773438-50.777343 50.773438-8.476563 0-16.460938-2.085938-23.484376-5.757813 8.476563 16.214844 25.449219 27.289063 45.015626 27.289063 28.042968 0 50.777343-22.730469 50.777343-50.773438 0-19.570312-11.074219-36.539062-27.292969-45.015625zm0 0"
        fill="#456ea2"
      ></path>
      <path
        d="m145.058594 138.371094 2.230468-2.230469c2.972657-2.972656 2.972657-7.796875 0-10.769531-2.976562-2.972656-7.796874-2.972656-10.773437 0l-2.230469 2.230468-2.230468-2.230468c-2.972657-2.972656-7.796876-2.972656-10.769532 0-2.976562 2.976562-2.976562 7.796875 0 10.769531l2.230469 2.230469-2.230469 2.230468c-2.976562 2.976563-2.976562 7.796876 0 10.773438 1.488282 1.484375 3.4375 2.230469 5.386719 2.230469s3.898437-.746094 5.386719-2.230469l2.226562-2.230469 2.230469 2.230469c1.488281 1.484375 3.4375 2.230469 5.386719 2.230469 1.949218 0 3.898437-.746094 5.386718-2.230469 2.976563-2.976562 2.976563-7.796875 0-10.773438zm0 0"
        fill="#315588"
      ></path>
      <path
        d="m333.621094 128.285156c-1.710938-3.804687-6.300782-5.382812-10.152344-3.785156l-4.269531 1.765625 3.269531-3.265625c2.945312-2.949219 3.246094-7.792969.390625-10.828125-2.960937-3.140625-7.90625-3.199219-10.9375-.167969l-3.492187 3.488282 1.890624-4.558594c1.609376-3.886719-.234374-8.34375-4.121093-9.953125-3.886719-1.613281-8.34375.234375-9.953125 4.121093l-4.136719 9.984376c-.996094 2.410156-.660156 4.964843.582031 6.953124 2.046875 3.277344 1.691406 7.503907-1.042968 10.238282l-.066407.0625c-3.035156 3.035156-3.203125 8.171875-.09375 11.132812 2.984375 2.84375 7.707031 2.800782 10.636719-.128906 3.179688-3.179688 7.320312-3.292969 10.605469-1.292969 1.167969.714844 2.53125 1.117188 3.964843 1.117188.972657 0 1.960938-.1875 2.914063-.582031l9.984375-4.136719c3.957031-1.640625 5.796875-6.230469 4.027344-10.164063zm0 0"
        fill="#28d05b"
      ></path>
      <path
        d="m312.492188 132.972656c-5.5625-1.492187-11.347657.277344-15.152344 4.40625l-24.988282-7.800781-18.492187 19.410156-7.847656 29.277344c-.089844-.023437-.179688-.054687-.269531-.082031-8.125-2.179688-16.476563 2.636718-18.660157 10.761718-2.183593 8.125 2.636719 16.480469 10.761719 18.664063 8.125 2.179687 16.480469-2.636719 18.660156-10.761719.628906-2.339844.726563-4.746094.21875-7.105468 1.558594 4.703124 5.410156 8.605468 10.554688 9.984374 8.128906 2.175782 16.480468-2.644531 18.660156-10.769531.667969-2.492187.695312-5.113281.074219-7.617187.6875 2.398437 1.976562 4.65625 3.867187 6.542968 5.949219 5.949219 15.59375 5.949219 21.539063 0 5.949219-5.949218 5.949219-15.59375 0-21.542968-1.875-1.875-4.175781-3.195313-6.632813-3.890625 8.070313 2.066406 16.316406-2.75 18.476563-10.820313 2.179687-8.125-2.640625-16.480468-10.769531-18.65625zm0 0"
        fill="#d9435b"
      ></path>
      <path
        d="m290.949219 111.441406c-11.328125-3.03125-21.671875 7.371094-18.652344 18.652344-1.761719-6.601562-7.769531-11.28125-14.714844-11.28125-3.898437 0-7.796875 1.484375-10.769531 4.460938-5.949219 5.949218-5.949219 15.59375 0 21.542968 2.054688 2.054688 4.542969 3.402344 7.175781 4.035156-8.296875-2.429687-16.816406 2.496094-19.007812 10.6875-2.175781 8.125 2.652343 16.476563 10.777343 18.652344 8.128907 2.171875 16.480469-2.652344 18.652344-10.78125.691406-2.578125.691406-5.292968 0-7.871094 1.722656 6.3125 7.460938 11.28125 14.714844 11.28125.023438 0 .046875-.003906.070312-.003906 13.394532-.058594 20.300782-16.402344 10.703126-26-1.980469-1.980468-4.316407-3.269531-6.761719-3.929687 8.109375 2.132812 16.421875-2.6875 18.589843-10.792969 2.175782-8.128906-2.652343-16.476562-10.777343-18.652344zm0 0"
        fill="#ff5368"
      ></path>
    </svg>
  ),
  sauce1: (props) => (
    <svg
      id="fi_4459563"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m304 128-27.396 10.302h-44.985l-23.619-10.302 30.634-122.538c.803-3.21 3.687-5.462 6.996-5.462h20.739c3.309 0 6.193 2.252 6.996 5.462z"
          fill="#ffe02f"
        ></path>
        <path
          d="m266.37 0h-20.74c-3.309 0-6.193 2.252-6.996 5.462l-30.634 122.537 22.932 10.302 18.275-10.302 27.396-109.584-3.238-12.953c-.802-3.21-3.686-5.462-6.995-5.462z"
          fill="#fbc700"
        ></path>
        <path
          d="m318.13 511.998h-124.26c-29.309 0-54.856-19.947-61.964-48.38-13.04-52.16-12.129-106.833 2.641-158.531l41.453-145.088h160l41.454 145.088c14.771 51.697 15.682 106.37 2.641 158.531-7.109 28.433-32.656 48.38-61.965 48.38z"
          fill="#ffe02f"
        ></path>
        <path
          d="m388.07 415.997c-1.391 15.999-4.049 31.925-7.974 47.625-3.554 14.216-11.723 26.311-22.654 34.851-10.94 8.541-24.652 13.527-39.312 13.527h-124.26c-29.309 0-54.857-19.944-61.966-48.377-3.925-15.7-6.583-31.627-7.974-47.625-.783-8.891 9.127-17.791 9.127-26.692 0-28.371 3.935-56.711 11.796-84.218l3.719-49.088 27.424-96.003 32.004-10.303h96l32.004 10.302 27.424 96.003 3.719 49.088c10.322 36.139 24.188 73.731 20.923 110.91z"
          fill="#ffe02f"
        ></path>
        <path
          d="m123.93 415.997h264.14c3.266-37.179-.299-74.771-10.621-110.91l-14.021-49.088h-214.856z"
          fill="#fff3de"
        ></path>
        <path
          d="m131.904 463.623c7.108 28.433 32.657 48.377 61.966 48.377h51.509c-29.309 0-54.857-19.944-61.966-48.377-3.925-15.7-6.583-31.627-7.974-47.625h-51.509c1.391 15.998 4.049 31.925 7.974 47.625z"
          fill="#fbc700"
        ></path>
        <path
          d="m227.505 159.996-15.995-10.302-35.514 10.302-27.424 96.003h51.51z"
          fill="#fbc700"
        ></path>
        <path
          d="m186.061 305.087 14.021-49.088h-51.509l-14.021 49.088c-7.86 27.506-11.796 55.846-11.796 84.218 0 8.901.391 17.802 1.174 26.692h51.509c-.783-8.891-1.174-17.791-1.174-26.692 0-28.371 3.935-56.712 11.796-84.218z"
          fill="#ffe5c2"
        ></path>
        <path
          d="m352 159.999h-192c-8.837 0-16-7.163-16-16 0-8.837 7.163-16 16-16h192c8.837 0 16 7.163 16 16 0 8.837-7.164 16-16 16z"
          fill="#fff3de"
        ></path>
        <path
          d="m195.51 144c0-8.837 7.163-16 16-16h-51.51c-8.837 0-16 7.164-16 16s7.163 16 16 16h51.509c-8.836-.001-15.999-7.164-15.999-16z"
          fill="#ffe5c2"
        ></path>
        <circle cx="256" cy="335.968" fill="#f24141" r="32"></circle>
      </g>
    </svg>
  ),
  sauce2: (props) => (
    <svg
      id="fi_6416582"
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m60.73 54v5.5a3.35757 3.35757 0 0 1 -3.18 3.5h-11.64a3.351 3.351 0 0 1 -3.18-3.5v-5.5z"
          fill="#ff7255"
        ></path>
        <circle cx="51.73" cy="46" fill="#ff7255" r="3"></circle>
        <path d="m56.73 13v4h-1.72-6.56-1.72v-4h3 4z" fill="#636a74"></path>
        <path
          d="m60.73 33v21h-18v-21zm-6 13a3 3 0 1 0 -3 3 2.996 2.996 0 0 0 3-3z"
          fill="#e6ecf4"
        ></path>
        <path d="m58.73 1v4h-5-4-5.48l-7.11 7.34-2.87-2.79 8.29-8.55z" fill="#636a74"></path>
        <path d="m49.73 5h4v8h-4z" fill="#4d5662"></path>
        <path
          d="m60.73 29.46v3.54h-18v-3.54a3.675 3.675 0 0 1 1.14-2.69c.94-.86 1.88-1.73 2.83-2.59a3.64144 3.64144 0 0 0 1.11-2.2 34.61764 34.61764 0 0 0 .64-4.98h6.56c.21 1.66.43 3.32.64 4.98a3.589 3.589 0 0 0 1.11 2.2c.94.86 1.88 1.73 2.82 2.59a3.64579 3.64579 0 0 1 1.15 2.69z"
          fill="#ff7255"
        ></path>
        <path d="m27.73 1v4h-5-4-5.47l-7.12 7.34-2.87-2.79 8.29-8.55z" fill="#636a74"></path>
        <path d="m18.73 5h4v8h-4z" fill="#4d5662"></path>
        <path d="m25.73 13v4h-1.72-6.56-1.72v-4h3 4z" fill="#636a74"></path>
        <g fill="#ff5666">
          <path d="m29.73 54v5.5a3.351 3.351 0 0 1 -3.18 3.5h-11.64a3.351 3.351 0 0 1 -3.18-3.5v-5.5z"></path>
          <path d="m29.73 29.46v3.54h-18v-3.54a3.69159 3.69159 0 0 1 1.14-2.69c.94-.86 1.89-1.73 2.83-2.59a3.64144 3.64144 0 0 0 1.11-2.2 34.61764 34.61764 0 0 0 .64-4.98h6.56c.21 1.66.43 3.32.64 4.98a3.64144 3.64144 0 0 0 1.11 2.2c.94.86 1.88 1.73 2.83 2.59a3.69159 3.69159 0 0 1 1.14 2.69z"></path>
          <path d="m20.92 43.01a2.9411 2.9411 0 1 1 -.19-.01 1.2102 1.2102 0 0 1 .19.01z"></path>
        </g>
        <path
          d="m20.92 43.01a1.2102 1.2102 0 0 0 -.19-.01 3.06682 3.06682 0 1 0 .19.01zm8.81-10.01v21h-18v-21z"
          fill="#e6ecf4"
        ></path>
      </g>
      <g>
        <g>
          <path d="m26.55078 64.001h-11.64355a4.35406 4.35406 0 0 1 -4.17774-4.50293v-30.03323a4.64411 4.64411 0 0 1 1.46778-3.42675l2.82324-2.59571a2.59944 2.59944 0 0 0 .79687-1.59179c.09766-.75977.22168-1.46973.33594-2.124a12.02906 12.02906 0 0 0 .2959-2.64551 1.00028 1.00028 0 0 1 1.99414-.16015 13.23145 13.23145 0 0 1 -.31934 3.15137c-.11035.626-.22949 1.30468-.32226 2.03222a4.60353 4.60353 0 0 1 -1.42776 2.81048l-2.82422 2.5957a2.64212 2.64212 0 0 0 -.82031 1.9541v30.03325a2.36 2.36 0 0 0 2.17776 2.50295h11.64355a2.36 2.36 0 0 0 2.17774-2.50293v-30.03323a2.645 2.645 0 0 0 -.81934-1.9541l-2.82518-2.59574a4.60357 4.60357 0 0 1 -1.42773-2.81055l-.63672-4.97656a1.00028 1.00028 0 0 1 1.98438-.25391l.63671 4.97657a2.59946 2.59946 0 0 0 .79688 1.59179l2.82422 2.59571a4.64692 4.64692 0 0 1 1.4668 3.42675v30.03325a4.35406 4.35406 0 0 1 -4.17776 4.50295z"></path>
          <path d="m25.72949 18.001h-10a.99943.99943 0 0 1 -1-1v-4a.99942.99942 0 0 1 1-1h10a.99942.99942 0 0 1 1 1v4a.99942.99942 0 0 1 -1 1zm-9-2h8v-2h-8z"></path>
          <path d="m18.72949 14.001a.99943.99943 0 0 1 -1-1v-8.001a1 1 0 0 1 2 0v8.001a.99942.99942 0 0 1 -1 1z"></path>
          <path d="m22.72949 14.001a.99943.99943 0 0 1 -1-1v-8.001a1 1 0 0 1 2 0v8.001a.99942.99942 0 0 1 -1 1z"></path>
          <path d="m6.14355 13.33594a1.00169 1.00169 0 0 1 -.69628-.28223l-2.8711-2.78516a.99975.99975 0 0 1 -.02148-1.41406l8.29-8.55078a.99945.99945 0 0 1 .71781-.30371h16.167a.99942.99942 0 0 1 1 1v4a.99942.99942 0 0 1 -1 1h-14.05079l-6.81738 7.03223a.99915.99915 0 0 1 -.70215.30371zm-1.45703-3.80664 1.43555 1.39258 6.416-6.61817a.99945.99945 0 0 1 .71779-.30371h13.47363v-2h-14.74414z"></path>
          <path d="m29.72852 34.001h-17.999a1 1 0 1 1 0-2h17.999a1 1 0 1 1 0 2z"></path>
          <path d="m29.72852 55.001h-17.999a1 1 0 1 1 0-2h17.999a1 1 0 1 1 0 2z"></path>
          <path d="m20.72949 50.001a4 4 0 1 1 4-4 4.004 4.004 0 0 1 -4 4zm0-6a2 2 0 1 0 2 2 2.0026 2.0026 0 0 0 -2-2z"></path>
          <path d="m20.72949 46.001h-.01172a1.00014 1.00014 0 0 1 -.98828-1.01172 13.51743 13.51743 0 0 1 3.23926-8.6377 1.00023 1.00023 0 1 1 1.52148 1.29883 11.52131 11.52131 0 0 0 -2.76074 7.36231 1.00012 1.00012 0 0 1 -1 .98828z"></path>
        </g>
        <g>
          <path d="m57.5498 64h-11.64355a4.35405 4.35405 0 0 1 -4.17773-4.50293v-30.0332a4.64412 4.64412 0 0 1 1.46777-3.42676l2.82324-2.59473a2.59946 2.59946 0 0 0 .79688-1.59179c.09765-.76075.22168-1.46973.33593-2.125a12.10078 12.10078 0 0 0 .2959-2.64551 1.00028 1.00028 0 1 1 1.99414-.16016 13.2244 13.2244 0 0 1 -.32031 3.15039c-.10937.627-.22852 1.30567-.32129 2.03418a4.60352 4.60352 0 0 1 -1.42773 2.81051l-2.82422 2.59473a2.64207 2.64207 0 0 0 -.82031 1.9541v30.0332a2.36 2.36 0 0 0 2.17773 2.50297h11.64355a2.36 2.36 0 0 0 2.17774-2.50293v-30.0332a2.645 2.645 0 0 0 -.81934-1.9541l-2.8252-2.59477a4.60353 4.60353 0 0 1 -1.42774-2.81055l-.63671-4.97745a1.00028 1.00028 0 1 1 1.98438-.2539l.63672 4.97754a2.59944 2.59944 0 0 0 .79687 1.59179l2.82422 2.59473a4.64694 4.64694 0 0 1 1.4668 3.42676v30.0332a4.35405 4.35405 0 0 1 -4.17774 4.50288z"></path>
          <path d="m56.72852 18h-10a.99942.99942 0 0 1 -1-1v-4a.99942.99942 0 0 1 1-1h10a.99943.99943 0 0 1 1 1v4a.99943.99943 0 0 1 -1 1zm-9-2h8v-2h-8z"></path>
          <path d="m49.72852 14a.99942.99942 0 0 1 -1-1v-8.001a1 1 0 0 1 2 0v8.001a.99943.99943 0 0 1 -1 1z"></path>
          <path d="m53.72852 14a.99942.99942 0 0 1 -1-1v-8.001a1 1 0 0 1 2 0v8.001a.99943.99943 0 0 1 -1 1z"></path>
          <path d="m37.14258 13.335a1.00169 1.00169 0 0 1 -.69629-.28223l-2.87109-2.78519a.99975.99975 0 0 1 -.02149-1.41406l8.29-8.55079a.99948.99948 0 0 1 .71781-.30373h16.167a.99943.99943 0 0 1 1 1v4a.99942.99942 0 0 1 -1 1h-14.05079l-6.81738 7.03223a.99915.99915 0 0 1 -.70215.30371zm-1.457-3.80664 1.43554 1.39258 6.416-6.61817a.99948.99948 0 0 1 .71777-.30371h13.47363v-2h-14.74414z"></path>
          <path d="m60.72754 34h-17.999a1 1 0 0 1 0-2h17.999a1 1 0 1 1 0 2z"></path>
          <path d="m60.72754 55h-17.999a1 1 0 0 1 0-2h17.999a1 1 0 1 1 0 2z"></path>
          <path d="m51.72852 50a4 4 0 1 1 4-4 4.004 4.004 0 0 1 -4 4zm0-6a2 2 0 1 0 2 2 2.0026 2.0026 0 0 0 -2-2z"></path>
        </g>
      </g>
    </svg>
  ),
  sauce3: (props) => (
    <svg
      id="fi_10771412"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 8"
      {...props}
    >
      <path
        d="m240 256.356v199.644a32 32 0 0 1 -32 32h-104a32 32 0 0 1 -32-32v-199.644a71.342 71.342 0 0 1 24.342-53.673l39.658-34.726v-55.957h40v55.957l39.658 34.727a71.342 71.342 0 0 1 24.342 53.672z"
        fill="#cd8c55"
      ></path>
      <path d="m136 80h40v32h-40z" fill="#dda174"></path>
      <path d="m144 24h24v56h-24z" fill="#efdfba"></path>
      <path
        d="m440 256.356v199.644a32 32 0 0 1 -32 32h-104a32 32 0 0 1 -32-32v-199.644a71.342 71.342 0 0 1 24.342-53.673l39.658-34.726v-55.957h40v55.957l39.658 34.727a71.342 71.342 0 0 1 24.342 53.672z"
        fill="#9a5a45"
      ></path>
      <path d="m336 80h40v32h-40z" fill="#dda174"></path>
      <g fill="#efdfba">
        <path d="m344 24h24v56h-24z"></path>
        <path d="m72 288h168v112h-168z"></path>
        <path d="m272 288h168v112h-168z"></path>
        <path d="m224.572 66.971-13.988-34.971h-82.584v-16h88a8 8 0 0 1 7.428 5.029l16 40z"></path>
        <path d="m424.572 66.971-13.988-34.971h-82.584v-16h88a8 8 0 0 1 7.428 5.029l16 40z"></path>
      </g>
      <path d="m88 304h40v88h-40z" fill="#fff" opacity=".4"></path>
      <path d="m288 304h40v88h-40z" fill="#fff" opacity=".4"></path>
      <path
        d="m296.343 202.684a71.342 71.342 0 0 0 -24.343 53.672v199.644a32 32 0 0 0 32 32h8v-200c0-40 12.281-67.5 24-82.5a60.355 60.355 0 0 0 12.656-37.181v-88.319h-12.656v87.957z"
        fill="#fff"
        opacity=".2"
      ></path>
      <path
        d="m415.412 202.684a71.342 71.342 0 0 1 24.343 53.673v199.643a32 32 0 0 1 -32 32h-8v-200c0-40-12.035-67.5-23.754-82.5a60.355 60.355 0 0 1 -12.656-37.181v-88.319h12.41v87.957z"
        fill="#67261e"
        opacity=".3"
      ></path>
      <path
        d="m96.588 202.684a71.342 71.342 0 0 0 -24.343 53.673v199.643a32 32 0 0 0 32 32h8v-200c0-40 12.281-67.5 24-82.5a60.355 60.355 0 0 0 12.655-37.181v-88.319h-12.654v87.957z"
        fill="#fff"
        opacity=".2"
      ></path>
      <path
        d="m215.657 202.684a71.342 71.342 0 0 1 24.343 53.672v199.644a32 32 0 0 1 -32 32h-8v-200c0-40-12.035-67.5-23.754-82.5a60.355 60.355 0 0 1 -12.656-37.181v-88.319h12.41v87.957z"
        fill="#67261e"
        opacity=".3"
      ></path>
      <path d="m144 32h24v16h-24z" fill="#67261e" opacity=".3"></path>
      <path d="m344 32h24v16h-24z" fill="#67261e" opacity=".3"></path>
    </svg>
  ),
  sauce4: (props) => (
    <svg
      id="fi_12412209"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path d="m341.632 28.455h30.117v61.854h-30.117z" fill="#ffc344"></path>
          <path
            d="m391.111 199.939v-73.014h-68.84v73.014c0 15.962-6.63 31.204-18.305 42.089-15.186 14.158-24.72 34.305-24.72 56.578v197.941c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.918 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578-11.676-10.885-18.306-26.127-18.306-42.089z"
            fill="#d4f2f6"
          ></path>
          <path
            d="m409.416 242.028c-11.675-10.885-18.305-26.127-18.305-42.089v-73.013h-30.903v73.013c0 15.962 6.63 31.204 18.305 42.089 15.186 14.158 24.72 34.305 24.72 56.578v197.941c0 8.534-6.918 15.453-15.453 15.453h30.903c8.534 0 15.453-6.919 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578z"
            fill="#a6e7f0"
          ></path>
          <path
            d="m322.271 177.706v22.233c0 15.962-6.63 31.204-18.305 42.089-15.186 14.158-24.72 34.305-24.72 56.578v197.941c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.919 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578-11.675-10.885-18.305-26.127-18.305-42.089v-22.233z"
            fill="#fff3de"
          ></path>
          <path
            d="m409.416 242.028c-11.675-10.885-18.305-26.127-18.305-42.089v-22.233h-30.903v22.233c0 15.962 6.63 31.204 18.305 42.089 15.186 14.158 24.72 34.305 24.72 56.578v161.37c0 8.534-6.918 15.453-15.453 15.453h-108.534v21.119c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.919 15.453-15.453v-197.942c-.001-22.273-9.535-42.42-24.721-56.578z"
            fill="#ffe5c2"
          ></path>
          <path
            d="m385.96 89.279h-58.538c-2.845 0-5.151 2.306-5.151 5.151v32.496h68.84v-32.496c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffe177"
          ></path>
          <path d="m279.246 311.934h154.89v135.529h-154.89z" fill="#ffbd86"></path>
          <path
            d="m298.444 0c-6.552 0-12.318 4.324-14.153 10.615l-9.576 32.832c-.962 3.297 1.511 6.593 4.945 6.593h19.983c2.289 0 4.304-1.511 4.945-3.709l4.914-16.846h76.459c2.845 0 5.151-2.306 5.151-5.151v-19.183c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffe177"
          ></path>
          <path d="m144.95 28.489h30.118v61.82h-30.118z" fill="#ffc344"></path>
          <path
            d="m194.429 199.939v-73.014h-68.84v73.014c0 15.962-6.63 31.204-18.305 42.089-15.186 14.158-24.72 34.305-24.72 56.578v197.941c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.918 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578-11.676-10.885-18.306-26.127-18.306-42.089z"
            fill="#d4f2f6"
          ></path>
          <path
            d="m212.734 242.028c-11.675-10.885-18.305-26.127-18.305-42.089v-73.013h-30.903v73.013c0 15.962 6.63 31.204 18.305 42.089 15.186 14.158 24.72 34.305 24.72 56.578v197.941c0 8.534-6.918 15.453-15.453 15.453h30.903c8.534 0 15.453-6.919 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578z"
            fill="#a6e7f0"
          ></path>
          <path
            d="m125.589 177.706v22.233c0 15.962-6.63 31.204-18.305 42.089-15.186 14.158-24.72 34.305-24.72 56.578v197.941c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.919 15.453-15.453v-197.941c0-22.273-9.534-42.42-24.72-56.578-11.675-10.885-18.305-26.127-18.305-42.089v-22.233z"
            fill="#fff3de"
          ></path>
          <path
            d="m212.734 242.028c-11.675-10.885-18.305-26.127-18.305-42.089v-22.233h-30.903v22.233c0 15.962 6.63 31.204 18.305 42.089 15.186 14.158 24.72 34.305 24.72 56.578v161.37c0 8.534-6.918 15.453-15.453 15.453h-108.534v21.119c0 8.534 6.918 15.453 15.453 15.453h123.985c8.534 0 15.453-6.919 15.453-15.453v-197.942c-.001-22.273-9.535-42.42-24.721-56.578z"
            fill="#ffe5c2"
          ></path>
          <path
            d="m189.278 89.279h-58.538c-2.845 0-5.151 2.306-5.151 5.151v32.496h68.84v-32.496c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffe177"
          ></path>
          <path
            d="m189.278 89.279h-25.752v37.647h30.903v-32.496c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffd15b"
          ></path>
          <path
            d="m385.96 89.279h-25.752v37.647h30.903v-32.496c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffd15b"
          ></path>
          <path d="m82.564 311.934h154.89v135.529h-154.89z" fill="#ffe177"></path>
          <path
            d="m194.594 348.728c-2.929-2.928-7.678-2.928-10.606 0l-13.918 13.919c2.266 1.105 4.368 2.569 6.203 4.405 1.835 1.835 3.298 3.937 4.404 6.203l13.918-13.918c2.928-2.932 2.928-7.68-.001-10.609z"
            fill="#d78878"
          ></path>
          <path d="m206.551 311.933h30.903v135.529h-30.903z" fill="#ffd15b"></path>
          <path d="m403.234 311.933h30.903v135.529h-30.903z" fill="#f6a96c"></path>
          <path
            d="m101.926.086c-6.51 0-12.247 4.277-14.105 10.517l-9.74 32.712c-.983 3.303 1.491 6.621 4.937 6.621h19.961c2.279 0 4.286-1.497 4.937-3.681l4.983-16.736h76.379c2.845 0 5.151-2.306 5.151-5.151v-19.131c0-2.845-2.306-5.151-5.151-5.151h-87.352z"
            fill="#ffe177"
          ></path>
          <path
            d="m189.278.086h-25.752v29.433h25.752c2.845 0 5.151-2.306 5.151-5.151v-19.131c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffd15b"
          ></path>
          <path
            d="m385.96.086h-25.752v29.433h25.752c2.845 0 5.151-2.306 5.151-5.151v-19.131c0-2.845-2.306-5.151-5.151-5.151z"
            fill="#ffd15b"
          ></path>
          <g>
            <path
              d="m369.948 392.955c-9.55 9.55-22.723 13.257-35.093 11.138-1.309-.224-2.334-1.249-2.559-2.559-2.119-12.37 1.588-25.543 11.138-35.093s22.723-13.257 35.093-11.138c1.309.224 2.334 1.249 2.559 2.559 2.119 12.37-1.588 25.543-11.138 35.093z"
              fill="#80d261"
            ></path>
            <path
              d="m381.086 357.862c-.224-1.309-1.25-2.334-2.559-2.559-3.073-.526-6.195-.692-9.299-.499-.548 9.449-4.422 18.74-11.642 25.96-7.178 7.178-16.402 11.053-25.794 11.636-.177 3.049-.013 6.115.504 9.133.224 1.309 1.249 2.334 2.559 2.558 12.37 2.119 25.543-1.588 35.093-11.138 9.55-9.548 13.257-22.721 11.138-35.091z"
              fill="#68ca44"
            ></path>
          </g>
          <g>
            <circle cx="160.009" cy="383.314" fill="#fe646f" r="24"></circle>
            <path
              d="m176.979 366.343c-1.812-1.812-3.844-3.264-6.007-4.375 1.902 7.862-.189 16.493-6.327 22.631-7.561 7.561-18.908 9.013-27.934 4.375 1.002 4.142 3.093 8.075 6.327 11.31 9.373 9.373 24.569 9.373 33.941 0 9.373-9.372 9.373-24.568 0-33.941z"
              fill="#fd4755"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  sauce5: (props) => (
    <svg
      height="512"
      viewBox="0 0 53 58"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2935550"
      {...props}
    >
      <g id="Page-1" fill="none" fill-rule="evenodd">
        <g id="065---Syrup" fill-rule="nonzero">
          <path
            id="Shape"
            d="m18.64 29-8.64 2-8.64-2c.19954054-.4343452.47369118-.8303406.81-1.17l2.78-2.78c1.31272392-1.3128579 2.05013395-3.0934333 2.05-4.95v-3.1l3-2 3 2v3.1c-.000134 1.8565667.7372761 3.6371421 2.05 4.95l2.78 2.78c.3363088.3396594.6104595.7356548.81 1.17z"
            fill="#f3d55b"
          ></path>
          <path id="Rectangle-path" d="m1 38h18v16h-18z" fill="#ecf0f1"></path>
          <path
            id="Shape"
            d="m24.829 7c-.2651948-.00005664-.5195073-.10545063-.707-.293l-2.415-2.414c-.1874927-.18754937-.4418052-.29294336-.707-.293h-9c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h9c.7959355-.00159843 1.5595245.31485357 2.121.879l2.415 2.414c.2859079.28599425.3714219.71603662.216678 1.08965456s-.5192821.61725909-.923678.61734544z"
            fill="#95a5a5"
          ></path>
          <path
            id="Shape"
            d="m19 30.66v5.34h-18v-5.34c.00155321-.5725335.1242405-1.1382582.36-1.66h17.28c.2357595.5217418.3584468 1.0874665.36 1.66z"
            fill="#f29c1f"
          ></path>
          <rect id="Rectangle-path" fill="#e57e25" height="5" rx="1" width="20" y="34"></rect>
          <path
            id="Shape"
            d="m10 12c-.55228475 0-1-.4477153-1-1v-5c0-.55228475.44771525-1 1-1 .5522847 0 1 .44771525 1 1v5c0 .5522847-.4477153 1-1 1z"
            fill="#95a5a5"
          ></path>
          <rect id="Rectangle-path" fill="#bdc3c7" height="6" rx="1" width="8" x="6" y="11"></rect>
          <rect id="Rectangle-path" fill="#bdc3c7" height="6" rx="1" width="8" x="6"></rect>
          <rect id="Rectangle-path" fill="#e57e25" height="5" rx="1" width="20" y="53"></rect>
          <path
            id="Shape"
            d="m14 45h-8c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            fill="#bdc3c7"
          ></path>
          <path
            id="Shape"
            d="m12 49h-4c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            fill="#bdc3c7"
          ></path>
          <path
            id="Shape"
            d="m50.37 28 .545-6.921c.0220811-.2786169-.0734446-.5537603-.2634274-.7587517s-.4570835-.3211219-.7365726-.3202483h-23.833c-.2794891-.0008736-.5465898.1152569-.7365726.3202483s-.2855085.4801348-.2634274.7587517l.548 6.921 1.73 22 .49 6.16c.0835941 1.0416439.9550126 1.8433489 2 1.84h16.3c1.0449874.0033489 1.9164059-.7983561 2-1.84l.49-6.16z"
            fill="#3b97d3"
          ></path>
          <path
            id="Shape"
            d="m25.289 49.079-1.578-20c-.0220811-.2786169.0734446-.5537603.2634274-.7587517s.4570835-.3211219.7365726-.3202483h26.581c.2794891-.0008736.5465898.1152569.7365726.3202483s.2855085.4801348.2634274.7587517l-1.578 20c-.0413027.5212175-.4771511.9226339-1 .921h-23.428c-.5216962.0000654-.955786-.4009343-.997-.921z"
            fill="#e4c05c"
          ></path>
          <path
            id="Shape"
            d="m42.2 43.2c-3.09 3.09-7.48 3.72-9.8 1.4-.2341872-.2368835-.4420631-.4984047-.62-.78 1.83-1.75 3.22-.42 5.05-2.25 1.87-1.87.47-3.27 2.34-5.14 1.83-1.83 3.22-.5 5.05-2.25 1.54 2.43.75 6.25-2.02 9.02z"
            fill="#805333"
          ></path>
          <path
            id="Shape"
            d="m44.22 34.18c-1.83 1.75-3.22.42-5.05 2.25-1.87 1.87-.47 3.27-2.34 5.14-1.83 1.83-3.22.5-5.05 2.25-1.54-2.43-.75-6.25 2.02-9.02 3.09-3.09 7.48-3.72 9.8-1.4.2341872.2368835.4420631.4984047.62.78z"
            fill="#a56a43"
          ></path>
          <g fill="#f29c1f">
            <path
              id="Shape"
              d="m35 13c.0001515.8433935-.3547159 1.6478959-.9776734 2.2164349-.6229574.568539-1.4564582.8485951-2.2963266.7715651-.8459061-.1141351-1.6090103-.5674095-2.1139122-1.2556377-.5049018-.6882283-.7081717-1.5522115-.5630878-2.3933623.3079195-1.5667034 1.1056206-2.99507172 2.278-4.079.3768946-.3430695.9514993-.34780762 1.334-.011 1.3717256 1.21627453 2.211555 2.9221445 2.339 4.751z"
            ></path>
            <path
              id="Shape"
              d="m47 13c.0001515.8433935-.3547159 1.6478959-.9776734 2.2164349-.6229574.568539-1.4564582.8485951-2.2963266.7715651-.8459061-.1141351-1.6090103-.5674095-2.1139122-1.2556377-.5049018-.6882283-.7081717-1.5522115-.5630878-2.3933623.3079195-1.5667034 1.1056206-2.99507172 2.278-4.079.3768946-.3430695.9514993-.34780762 1.334-.011 1.3717256 1.21627453 2.211555 2.9221445 2.339 4.751z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  sauce6: (props) => (
    <svg
      id="fi_3106132"
      enable-background="new 0 0 497 497"
      height="512"
      viewBox="0 0 497 497"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m136.916 0h-16.831c-3.767 0-6.949 2.794-7.437 6.529l-10.898 83.471 26.75 30 26.75-30-10.898-83.471c-.487-3.735-3.67-6.529-7.436-6.529z"
          fill="#ffba48"
        ></path>
        <path d="m173.5 90-30 90h60v-60c0-16.569-13.431-30-30-30z" fill="#ff5a35"></path>
        <path d="m143.5 90-30 90h60v-90z" fill="#ff7a3c"></path>
        <path d="m113.5 90-30 90h60v-90z" fill="#ff9a42"></path>
        <path d="m83.5 90-30 90h60v-90z" fill="#ff7a3c"></path>
        <path d="m53.5 120v60h30v-90c-16.569 0-30 13.431-30 30z" fill="#ff9a42"></path>
        <path
          d="m203.5 150h-30v347h30c16.569 0 30-13.431 30-30v-287c0-16.569-13.431-30-30-30z"
          fill="#ff9a42"
        ></path>
        <path
          d="m203.5 467v-287c0-16.569-13.431-30-30-30h-120c-16.569 0-30 13.431-30 30v287c0 16.569 13.431 30 30 30h120c16.569 0 30-13.431 30-30z"
          fill="#ffba48"
        ></path>
        <path
          d="m376.916 0h-16.831c-3.767 0-6.949 2.794-7.437 6.529l-10.898 83.471 26.75 30 26.75-30-10.898-83.471c-.487-3.735-3.67-6.529-7.436-6.529z"
          fill="#ff3a2f"
        ></path>
        <path d="m413.5 90-30 90h60v-60c0-16.569-13.431-30-30-30z" fill="#ff3a2f"></path>
        <path d="m383.5 90-30 90h60v-90z" fill="#ff5a35"></path>
        <path d="m353.5 90-30 90h60v-90z" fill="#ff7a3c"></path>
        <path d="m323.5 90-30 90h60v-90z" fill="#ff5a35"></path>
        <path d="m293.5 120v60h30v-90c-16.569 0-30 13.431-30 30z" fill="#ff7a3c"></path>
        <path
          d="m443.5 150h-30v347h30c16.569 0 30-13.431 30-30v-287c0-16.569-13.431-30-30-30z"
          fill="#db2116"
        ></path>
        <path
          d="m443.5 467v-287c0-16.569-13.431-30-30-30h-120c-16.569 0-30 13.431-30 30v287c0 16.569 13.431 30 30 30h120c16.569 0 30-13.431 30-30z"
          fill="#ff3a2f"
        ></path>
      </g>
    </svg>
  ),
  sauce7: (props) => (
    <svg
      id="fi_9126289"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m194.337 188.657-74.901 10.302-74.888-10.301c12.517-23.674 24.22-42.64 24.22-66.272v-55.064h101.339v55.063c0 23.633 11.703 42.598 24.23 66.272z"
          fill="#fd8087"
        ></path>
        <path
          d="m224.324 459.183v32.213c0 11.384-9.229 20.604-20.602 20.604h-168.569c-11.373 0-20.603-9.22-20.603-20.604v-32.213l104.886-10.302z"
          fill="#fd8087"
        ></path>
        <path
          d="m194.337 188.657h-28.845c-12.527-23.674-24.23-42.639-24.23-66.271v-55.064h28.845v55.063c0 23.633 11.703 42.598 24.23 66.272z"
          fill="#fe646f"
        ></path>
        <path
          d="m224.324 459.183v32.213c0 11.384-9.229 20.604-20.602 20.604h-28.845c11.373 0 20.602-9.22 20.602-20.604v-32.213z"
          fill="#fe646f"
        ></path>
        <path
          d="m14.552 303.777c0 14.378-.002 98.579-.002 155.406h209.774c0-56.827-.004-141.028-.004-155.406 0-54.251-15.551-87.82-29.995-115.119h-149.777c-14.445 27.299-29.996 60.868-29.996 115.119z"
          fill="#fef1da"
        ></path>
        <path
          d="m195.479 303.777v155.406h28.845c0-56.827-.004-141.029-.004-155.406 0-54.251-15.551-87.82-29.995-115.119h-28.845c14.445 27.299 29.999 60.868 29.999 115.119z"
          fill="#fae2c0"
        ></path>
        <path
          d="m119.436 293.819c-4.267 0-7.726-3.459-7.726-7.726v-30.044c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v30.044c0 4.267-3.459 7.726-7.726 7.726z"
          fill="#e19974"
        ></path>
        <ellipse cx="119.436" cy="334.973" fill="#fd8087" rx="56.531" ry="51.543"></ellipse>
        <path
          d="m167.169 308.884-24.094-7.046c-2.079-.608-4.193.841-4.377 2.998l-1.363 15.982c-.222 2.599-3.487 3.618-5.147 1.607l-10.666-12.92c-1.082-1.311-3.091-1.311-4.173 0l-10.666 12.92c-1.661 2.012-4.926.993-5.147-1.607l-1.363-15.982c-.184-2.158-2.298-3.606-4.377-2.998l-24.094 7.046c-1.977.578-3.66-1.509-2.698-3.331 9.328-17.66 28.41-29.762 50.431-29.762s41.103 12.102 50.431 29.762c.963 1.822-.72 3.909-2.697 3.331z"
          fill="#97da7b"
        ></path>
        <path
          d="m169.016 86.984h-99.16c-4.286 0-7.761-3.475-7.761-7.761v-71.462c0-4.286 3.475-7.761 7.761-7.761h99.161c4.286 0 7.761 3.475 7.761 7.761v71.462c-.001 4.286-3.475 7.761-7.762 7.761z"
          fill="#fef1da"
        ></path>
        <path
          d="m168.782 0h-26.785c4.415 0 7.995 3.579 7.995 7.995v70.993c0 4.415-3.579 7.995-7.995 7.995h26.785c4.415 0 7.995-3.58 7.995-7.995v-70.993c0-4.416-3.579-7.995-7.995-7.995z"
          fill="#fae2c0"
        ></path>
        <path
          d="m122.964 36.796h-5.336c-7.517 0-13.611-6.094-13.611-13.611v-23.185h32.558v23.184c0 7.518-6.094 13.612-13.611 13.612z"
          fill="#fae2c0"
        ></path>
        <path
          d="m427.602 250.089v-54.081h-94.933v54.081c0 4.402-2.766 8.345-6.924 9.791-13.427 4.67-42.846 18.649-56.152 54.289 23.053 39.838 22.958 29.823 53.648 97.763.362.802-33.302 47.059-33.111 47.915.2.896.305 1.813.305 2.735v40.919c0 4.694 3.805 8.498 8.498 8.498h162.405c4.694 0 8.498-3.805 8.498-8.498v-40.919c0-.901.099-1.798.29-2.675s-7.61-6.336-7.239-7.158c30.69-67.94 19.909-96.982 27.795-138.583-13.306-35.64-42.729-49.616-56.157-54.286-4.157-1.446-6.923-5.389-6.923-9.791z"
          fill="#fe9738"
        ></path>
        <path
          d="m434.526 259.88c-4.158-1.446-6.924-5.389-6.924-9.791v-54.081h-27.815v65.413c0 4.402 2.766 8.345 6.924 9.791 24.717 8.597 103.638 41.516 36.446 190.261-.742 1.643-1.136 3.428-1.136 5.23v36.799c0 4.693-3.805 8.498-8.498 8.498h27.815c4.694 0 8.498-3.805 8.498-8.498v-40.919c0-.901.099-1.798.29-2.675s-6.841-5.054-6.47-5.875c30.69-67.94 11.446-104.02 27.027-139.866-13.306-35.64-42.73-49.617-56.157-54.287z"
          fill="#fe7d43"
        ></path>
        <path
          d="m490.673 314.17h-61.825c-2.061 0-4.037-.819-5.494-2.276l-35.935-35.935c-4.023-4.023-10.546-4.023-14.569 0l-35.935 35.935c-1.457 1.457-3.433 2.275-5.494 2.275h-61.83c-11.189 29.966-10.987 75.239 19.706 143.183.363.803.64 1.639.831 2.495h180.013c.191-.856.467-1.693.83-2.495 30.694-67.944 30.892-113.216 19.702-143.182z"
          fill="#fef1da"
        ></path>
        <path
          d="m470.142 459.847c.191-.856.467-1.693.83-2.495 30.692-67.944 30.891-113.216 19.701-143.182h-31.084c14.148 27.722 16.953 72.608-15.714 145.677z"
          fill="#fae2c0"
        ></path>
        <path
          d="m321.43 157.541v46.873c0 3.414 2.767 6.181 6.181 6.181h105.501c3.414 0 6.181-2.767 6.181-6.181v-46.873c0-3.414-2.767-6.181-6.181-6.181h-105.501c-3.414 0-6.181 2.767-6.181 6.181z"
          fill="#fef1da"
        ></path>
        <path
          d="m433.112 151.36h-23.694c3.414 0 6.181 2.767 6.181 6.181v46.873c0 3.414-2.767 6.181-6.181 6.181h23.694c3.414 0 6.181-2.767 6.181-6.181v-46.873c0-3.414-2.767-6.181-6.181-6.181z"
          fill="#fae2c0"
        ></path>
        <path
          d="m380.361 180.031c-12.932 0-23.416 10.484-23.416 23.416v7.148h46.832v-7.148c0-12.932-10.483-23.416-23.416-23.416z"
          fill="#fae2c0"
        ></path>
        <path
          d="m375.765 335.022-23.021 23.021c-2.414 2.414-2.414 6.327 0 8.741l23.021 23.021c2.414 2.414 6.328 2.414 8.741 0l23.021-23.021c2.414-2.414 2.414-6.327 0-8.741l-23.021-23.021c-2.414-2.414-6.327-2.414-8.741 0z"
          fill="#fd8087"
        ></path>
        <path
          d="m411.672 429.684h-63.072c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h63.072c4.143 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z"
          fill="#e19974"
        ></path>
      </g>
    </svg>
  ),
  item1: (props) => (
    <svg
      id="fi_15625538"
      viewBox="0 0 290 274.39"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      {...props}
    >
      <g transform="translate(-5 -12.8)">
        <path
          d="m165.21 249.61c.56-2.79.41-5.26 1.38-8.16.5-30.26 6.09-92.13 6.8-99.81h-5.76c-.61 5.84-4.11 36.92-5.44 47.7a55.35 55.35 0 0 1 -1 14l-2 37.6a84.17 84.17 0 0 1 6.02 8.67z"
          fill="#c4b0ab"
        ></path>
        <path
          d="m206.68 170.45c-3.38 4.16-37.07 49.52-41.47 77.19a103.22 103.22 0 0 1 4.32 10.57c7.27-28.16 25.33-64.08 42.74-83.38a2 2 0 0 0 0-1.66c-.65-1.22-2.61-2.17-5.59-2.72z"
          fill="#dbdba5"
        ></path>
        <path
          d="m162.59 191.87c-.76-17.46-7.07-37.07-7.16-37.33-9.68-32.39-43.32-43.48-49-45.13-.85 3.37-3.25 17.62 9.48 38.65 20.4 33.68 39 51.67 44.86 56.87a9.27 9.27 0 0 0 1.62-4.5c.11-1.25.18-2.54.2-3.86z"
          fill="#b0ce78"
        ></path>
        <path
          d="m144.83 217.73-3.19 4.27c28.21 23.8 26.55 58.6 26.53 62.7 1.83 1.88 3.53 2.7 5.06 2.46 2-.31 3.22-2.35 3.56-3-4.21-42.76-27.71-63.08-31.96-66.43z"
          fill="#bbc782"
        ></path>
        <path
          d="m287.17 69.26c-18.94-5.35-63.68 17.62-76.1 50.57-11.05 29.32-6.49 48.47-5.77 51.81 1.28.23 2.76 1.72 3.7 2.09 25.14-44 69.24-86.69 79.47-103.9a5.7 5.7 0 0 0 -1.3-.57z"
          fill="#72a644"
        ></path>
        <path
          d="m210.92 175.73a3.56 3.56 0 0 1 .18.49l3.85.32c56.69-1.26 75.45-47.35 79.29-75.38 2.12-15.48-.3-28.14-5.75-31.31-10.87 11.3-55.85 59.15-81 103.13 0 .02 2.88 1.59 3.43 2.75z"
          fill="#83b552"
        ></path>
        <path
          d="m174.81 14.41c-12.36 7.41-25.68 36.59-28.5 62.41-3.31 30.3 18.3 62 21 65.74l2.55-.17c7-24.41 14.92-95.48 10.21-129.58a9.77 9.77 0 0 0 -5.26 1.6z"
          fill="#84a048"
        ></path>
        <path
          d="m175.34 141c31.46-27.41 31.23-63 28.23-81.92-3.84-24.27-15.19-43.33-21.31-45.79a6.35 6.35 0 0 0 -2.23-.44c-1.85 17.6-9.6 93.1-10.21 129.58l3.71-.25z"
          fill="#8ead55"
        ></path>
        <path
          d="m143.25 220.14 1.58-2.4-3.3-4.82a.84.84 0 0 1 -.11-.19c-.2-.48-20.4-48.17-72.1-49.41-32.32-.81-51.32 6.53-61.61 12.82a5.63 5.63 0 0 0 -2.71 4.62c11.45-1.76 67.42 1.7 138.25 39.38z"
          fill="#698940"
        ></path>
        <path
          d="m7.9 186c19.43 11.22 68.23 37.33 101.5 37.33.23 0 21.06.55 32.23-1.37a.85.85 0 0 1 .37 0l1.24-1.89c-62.14-48.4-126.79-41.07-138.24-39.31v.32a5.77 5.77 0 0 0 2.9 4.92z"
          fill="#7a994d"
        ></path>
      </g>
    </svg>
  ),
  item2: (props) => (
    <svg
      id="fi_8782294"
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m40 31.64c-1.17 1.18-1.7 2.91-2.21 4.5-.25.79-.57 1.59-.98 2.31-.44.71-.99 1.33-1.73 1.73-.06.03-.12.06-.18.09-.75.36-1.52.4-2.14.36-.29-.02-.54-.05-.74-.08-1.13-.15-2.03-.59-2.58-.94.64-.15.72-.54.61-1.55-.03-.23-.06-.47-.12-.7 1-1.16 2.58-2.7 4.87-3.92 2.02-1.09 3.89-1.58 5.2-1.8z"
        fill="#d5ef9c"
      ></path>
      <path
        d="m24.13 39.03c-.55-.19-1.07-.45-1.49-.82-.07-.06-.13-.12-.19-.18-.95-.98-1.12-2.46-1.29-3.83-.17-1.36-.47-2.85-1.56-3.69 2.23.21 4.5.7 6.42 1.82v.01c.32.18.63.38.93.6 1.43 1.07 2.58 2.66 2.98 4.42.06.23.09.47.12.7.11 1.01.03 1.4-.61 1.55-.18.04-.4.05-.68.06-1.25.03-2.5-.11-3.71-.39-.31-.07-.62-.15-.92-.25z"
        fill="#d5ef9c"
      ></path>
      <path
        d="m22.64 38.21c.42.37.94.63 1.49.82-1.79.59-3.88 1.47-6.06 2.81-.83.51-1.6 1.04-2.3 1.56-.79.09-1.76.28-2.82.64-1.59.54-2.8 1.29-3.64 1.9.12-.64.27-1.31.44-2.01.17-.68.36-1.32.54-1.92-.97.32-2.15.83-3.38 1.62-2.37 1.52-3.79 3.4-4.57 4.62.04-1.46.33-4.15 2.01-6.88.73-1.18 1.54-2.08 2.26-2.74-.4-.06-.9-.1-1.47-.06-.79.07-1.43.27-1.87.45.66-.9 1.93-2.39 4.01-3.49 1.36-.73 2.62-1.05 3.53-1.21h.01c.54.35 1.06.71 1.58 1.08 1.69 1.19 3.39 2.42 5.35 3.06 1.17.38 2.8.42 4.89-.25z"
        fill="#609000"
      ></path>
      <path
        d="m61.18 47.6c1.15 2.39 1.59 5.08 1.6 7.74-1.16-1.62-2.93-2.71-4.78-3.39-1.87-.69-3.84-.99-5.81-1.29.72 1.94 1.46 3.86 2.24 5.76-3.46-1.74-6.02-4.85-8.48-7.86-.37 1.37-.75 2.72-1.13 4.09-.87-1.1-2.27-2.68-4.27-4.28-1.51-1.18-2.15-1.45-2.95-2.17-1.09-1-2.27-2.73-2.7-5.93l.18-.09c.74-.4 1.29-1.02 1.73-1.73.16-.04.31-.08.45-.12 2.73-.76 5.22-2.22 7.42-4.03h.01c1.47-.07 3.13-.05 4.96.18 2.43.31 4.49.87 6.09 1.44-1.03.5-2.05 1-3.08 1.51 1.24.47 2.66 1.1 4.16 1.97 1.72 1 3.12 2.05 4.22 3.01-.61-.26-1.62-.59-2.87-.63-1.07-.03-1.94.15-2.53.34 2.46 1.01 4.38 3.08 5.54 5.48z"
        fill="#92c538"
      ></path>
      <path
        d="m40.824 41.861c2.404-3.819 6.627-3.706 10.606-3.561.895.033 1.735-.103 2.546-.33-.454-.198-.898-.382-1.316-.54 1.03-.51 2.05-1.01 3.08-1.51-1.6-.57-3.66-1.13-6.09-1.44-1.83-.23-3.49-.25-4.96-.18h-.01c-2.2 1.81-4.69 3.27-7.42 4.03-.14.04-.29.08-.45.12-.44.71-.99 1.33-1.73 1.73-.06.03-.12.06-.18.09.43 3.2 1.61 4.93 2.7 5.93.57.513 1.064.802 1.843 1.349-.167-1.908.229-3.859 1.381-5.688z"
        fill="#609000"
      ></path>
      <path
        d="m55.06 13.86c-.23 2.78-1.4 5.42-3.02 7.7-1.6 2.29-3.64 4.23-5.76 6.06 2.41-.49 4.73-1.42 6.81-2.75-2.11 2.84-4.27 5.66-6.84 8.07-.5.47-1.02.93-1.56 1.36h-.01c-2.2 1.81-4.69 3.27-7.42 4.03-.14.04-.29.08-.45.12.41-.72.73-1.52.98-2.31.51-1.59 1.04-3.32 2.21-4.5-1.31.22-3.18.71-5.2 1.8-2.29 1.22-3.87 2.76-4.87 3.92-.4-1.76-1.55-3.35-2.98-4.42-.3-.22-.61-.42-.93-.6v-.01c-.2-2.29.06-4.71.44-6.62.01-.03.01-.07.02-.1.47-2.29 1.31-4.5 2.53-6.49.44.89.88 1.77 1.32 2.66.42-2.76 1.29-5.44 2.54-7.92.81-1.62 1.79-3.16 2.93-4.58.75 1.72 1.51 3.44 2.28 5.15.92-1.87 2.71-4.84 5.9-7.55 4.1-3.46 8.35-4.67 10.51-5.12-.78 1.98-1.55 4.17-2.26 6.56-.7 2.41-1.24 4.68-1.66 6.78.39.12 1.19.3 2.16.1 1.28-.28 2.06-1.05 2.33-1.34z"
        fill="#92c538"
      ></path>
      <path
        d="m33.82 43.93c.17 1.23.13 2.56-.33 4.43-1.02 4.08-3.34 7.69-5.63 11.23.2-1.64-.12-3.34-.92-4.77-1.92 2.98-4.43 5.58-7.34 7.61.17-1.54.33-3.07.49-4.6-3.55 1.72-7.11 3.44-10.66 5.17.91-3.35 2.35-6.61 4.01-9.66-1.84.63-3.55 1.62-5.03 2.89 1.73-3.24 3.97-6.2 6.62-8.73-1.21-.21-2.47-.21-3.68 0 1.03-1.19 2.49-2.65 4.42-4.1.7-.52 1.47-1.05 2.3-1.56 2.18-1.34 4.27-2.22 6.06-2.81.3.1.61.18.92.25 1.21.28 2.46.42 3.71.39.28-.01.5-.02.68-.06.55.35 1.45.79 2.58.94.2.03.45.06.74.08.45.86.87 1.98 1.06 3.3z"
        fill="#92c538"
      ></path>
      <path
        d="m32.87 13.86c-1.25 2.48-2.12 5.16-2.54 7.92-.44-.89-.88-1.77-1.32-2.66-1.22 1.99-2.06 4.2-2.53 6.49-.01.03-.01.07-.02.1-1.02-3.02-3.11-5.66-5.77-7.4-.05-2.75.5-5.53 1.6-8.05.63.85 1.09 1.41 1.72 2.26 1.06-3.19 1.4-6.57 1.17-9.94 2.34 2.32 3.97 5.34 4.62 8.56.99-.94 1.59-2.26 1.82-3.6.74 2.02 1.16 4.16 1.25 6.32z"
        fill="#609000"
      ></path>
      <path
        d="m20.69 18.31c2.66 1.74 4.75 4.38 5.77 7.4-.38 1.91-.64 4.33-.44 6.62-1.92-1.12-4.19-1.61-6.42-1.82 1.09.84 1.39 2.33 1.56 3.69.17 1.37.34 2.85 1.29 3.83.06.06.12.12.19.18-2.09.67-3.72.63-4.89.25-1.96-.64-3.66-1.87-5.35-3.06-.52-.37-1.04-.73-1.58-1.08h-.01c-1.2-.78-2.45-1.46-3.83-1.83 1.06-.64 2.22-1.12 3.42-1.43-1.47-.52-2.98-1.08-4.53-1.7-1.08-.42-2.13-.85-3.17-1.29.68-.37 1.63-.79 2.81-1.06.92-.2 1.73-.26 2.38-.26-1.1-1.2-2.28-2.45-3.54-3.69-1.09-1.1-2.17-2.12-3.23-3.08 1.38-.47 3.29-.94 5.61-1.06 2.5-.13 4.59.21 6.05.56-.1-.55-.24-1.15-.42-1.78-.17-.62-.36-1.17-.55-1.68.94.2 2.33.6 3.8 1.5 1.78 1.07 2.91 2.36 3.53 3.21-.44-1.29-.87-2.56-1.32-3.85 1.01.36 1.97.85 2.87 1.43z"
        fill="#92c538"
      ></path>
      <path
        d="m26.46 25.71c-.824-2.44-2.354-4.623-4.312-6.292.457 1.36.64 2.796.462 4.133-.243 1.826-1.069 3.345-2.689 4.295-1.558.914-2.964.608-3.166 2.649-.196 1.979.432 3.403-.564 5.366-.26.512-.6.981-.994 1.399.814.481 1.654.907 2.553 1.201 1.17.38 2.8.42 4.89-.25-.07-.06-.13-.12-.19-.18-.95-.98-1.12-2.46-1.29-3.83-.17-1.36-.47-2.85-1.56-3.69 2.23.21 4.5.7 6.42 1.82-.2-2.291.06-4.711.44-6.621z"
        fill="#609000"
      ></path>
      <g fill="none">
        <path d="m45.092 21.665c.083.525.68.845 1.21.798.959-.085 3.259-1.617 1.757-2.522-.884-.533-3.148.581-2.967 1.724z"></path>
        <path
          d="m26.945 32.942c-2.097-1.559-4.748-2.182-7.35-2.428 1.092.833 1.392 2.326 1.563 3.689s.339 2.843 1.293 3.831c.677.701 1.646 1.032 2.596 1.249 1.212.277 2.466.413 3.71.385 1.266-.029 1.433-.313 1.291-1.605-.224-2.041-1.478-3.913-3.103-5.121z"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m29.932 37.356c.994-1.155 2.58-2.691 4.87-3.916 2.018-1.094 3.886-1.576 5.201-1.797-1.175 1.175-1.707 2.912-2.209 4.498-.512 1.576-1.245 3.253-2.711 4.036-1.155.633-2.38.462-3.062.372-1.145-.151-2.038-.592-2.591-.944"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m26.017 32.335c-.201-2.329.07-4.8.462-6.727.472-2.289 1.315-4.498 2.53-6.486.442.884.884 1.767 1.325 2.661.693-4.548 2.601-8.906 5.462-12.501.753 1.717 1.516 3.434 2.279 5.151.924-1.868 2.711-4.84 5.904-7.551 4.097-3.464 8.354-4.669 10.513-5.121-.783 1.978-1.556 4.167-2.259 6.557-.703 2.41-1.245 4.679-1.667 6.778.392.12 1.195.301 2.159.1 1.285-.271 2.068-1.044 2.34-1.335-.231 2.781-1.406 5.422-3.022 7.701-1.607 2.289-3.645 4.227-5.763 6.055 2.41-.482 4.729-1.416 6.808-2.741-2.109 2.832-4.267 5.653-6.838 8.063-2.57 2.42-5.593 4.438-8.987 5.392-.141.04-.291.08-.452.12"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m30.161 36.382c.651-1.661 1.61-3.93 2.938-6.54 1.676-3.293 3.384-6.038 5.95-9.758 2.589-3.752 6.219-8.74 10.993-14.547"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m32.956 30.124c-.171-1.735-.341-3.469-.512-5.204"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m35.633 25.541c1.42.101 2.847.201 4.266.09s2.843-.443 4.075-1.156"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m37.492 22.301c-.737-1.713-1.228-3.53-1.454-5.381"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m40.416 18.295c2.593.005 5.187-.406 7.652-1.212"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m43.484 13.821c-.031-1.259.106-2.521.403-3.745"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m22.643 38.209c-2.088.673-3.725.633-4.89.251-1.958-.643-3.665-1.868-5.352-3.062-1.687-1.185-3.424-2.38-5.422-2.912 1.064-.633 2.219-1.115 3.424-1.426-1.476-.522-2.982-1.084-4.528-1.697-1.084-.422-2.139-.853-3.173-1.295.683-.372 1.627-.783 2.811-1.054.914-.201 1.727-.261 2.38-.261-1.104-1.205-2.279-2.45-3.544-3.695-1.084-1.094-2.169-2.119-3.233-3.083 1.386-.462 3.293-.934 5.613-1.054 2.5-.131 4.589.211 6.055.562-.1-.552-.241-1.155-.422-1.787-.171-.612-.361-1.165-.552-1.677.944.201 2.329.602 3.805 1.496 1.777 1.074 2.902 2.37 3.524 3.213-.442-1.285-.874-2.56-1.315-3.846 4.006 1.436 7.27 4.789 8.635 8.826"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m7.774 21.988c2.541.624 5.607 1.683 8.806 3.522 1.57.903 2.936 1.857 4.11 2.786"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m20.695 18.328c-.05-2.761.492-5.543 1.596-8.073.633.853 1.084 1.416 1.717 2.269 1.064-3.193 1.406-6.577 1.175-9.94 2.34 2.319 3.966 5.332 4.619 8.555.984-.944 1.586-2.259 1.817-3.595.743 2.018 1.165 4.157 1.255 6.316"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m32.764 40.629c.442.864.864 1.978 1.054 3.303.171 1.225.131 2.56-.331 4.428-1.014 4.077-3.334 7.691-5.623 11.226.201-1.637-.12-3.334-.924-4.769-1.918 2.982-4.428 5.583-7.34 7.611.171-1.536.331-3.072.492-4.599-3.554 1.717-7.108 3.444-10.663 5.171.914-3.354 2.35-6.607 4.006-9.659-1.837.633-3.544 1.617-5.02 2.892 1.727-3.243 3.966-6.205 6.617-8.736-1.215-.211-2.47-.211-3.685 0 1.416-1.617 3.615-3.755 6.727-5.653 2.189-1.345 4.287-2.229 6.075-2.821"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m14.792 56.578c1.353-2.353 3.093-4.985 5.324-7.691 2.22-2.693 4.452-4.885 6.47-6.637"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m44.682 34.303c1.466-.07 3.133-.05 4.97.181 2.43.301 4.488.864 6.085 1.436-1.024.502-2.048 1.004-3.072 1.506 1.235.472 2.651 1.104 4.157 1.978 1.717.994 3.123 2.048 4.217 3.002-.612-.261-1.617-.582-2.872-.623-1.064-.03-1.938.151-2.53.331 2.46 1.014 4.388 3.083 5.543 5.482 1.155 2.39 1.586 5.081 1.596 7.741-1.155-1.617-2.922-2.711-4.779-3.394-1.868-.683-3.836-.984-5.804-1.285.713 1.938 1.456 3.856 2.239 5.763-3.464-1.747-6.024-4.85-8.485-7.862-.372 1.366-.743 2.721-1.125 4.087-.874-1.094-2.269-2.681-4.277-4.277-1.506-1.185-2.149-1.446-2.942-2.169-1.094-1.004-2.269-2.731-2.701-5.934"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m36.79 38.47c3.334.542 7.48 1.627 11.888 3.836 4.49 2.24 7.832 4.927 10.122 7.108"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m10.825 34.323c-.917.156-2.182.482-3.544 1.205-2.081 1.105-3.354 2.59-4.01 3.487.443-.179 1.08-.379 1.866-.442.576-.046 1.076-.006 1.468.055-.711.663-1.525 1.565-2.254 2.745-1.683 2.726-1.973 5.419-2.014 6.876.779-1.224 2.207-3.095 4.567-4.617 1.236-.797 2.418-1.298 3.389-1.621-.189.601-.371 1.24-.54 1.915-.176.7-.321 1.373-.442 2.014.836-.612 2.051-1.356 3.636-1.899 1.062-.364 2.03-.548 2.827-.642"
          stroke="#486c00"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m40.507 39.249s5.329-1.51 8.333-1.461"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m44.712 40.618c.338.51 2.799 4.262 3.42 6.502"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m49.52 42.72 3.322-.65"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m19.254 50.051.862 3.381"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m17.921 51.713-1.995.563"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m22.367 46.407c.166.361 1.058 2.374 1.236 4.199"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m21.075 47.714c-.316.05-2.337.394-4.053 1.331"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m24.511 44.093c-.364-.035-2.638-.232-4.395.176"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m26.097 42.791c.26.522 1.744 3.61 1.526 5.688"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m15.926 25.144c.004-.518-.033-1.151-.164-1.86-.127-.684-.31-1.269-.491-1.741"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m17.44 26.053c-.792-.01-1.835.055-3.021.34-1.241.299-2.234.744-2.947 1.129"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
        <path
          d="m19.672 27.522c-.117-.471-.221-1.117-.177-1.882.025-.446.096-.838.177-1.165"
          stroke="#486c00"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
        ></path>
      </g>
    </svg>
  ),
  item3: (props) => (
    <svg
      height="512"
      viewBox="0 0 58 58"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2160302"
      {...props}
    >
      <g id="049---Spices" fill="none" transform="translate(0 -1)">
        <path
          id="Shape"
          d="m34 30 20-3 1.47.62-.22 1.08c-1.2898908 6.5627665-7.0416736 11.2965717-13.73 11.3h-1.52z"
          fill="#805333"
        ></path>
        <path
          id="Shape"
          d="m18 17v5.22l21.68 11.68c6.81-.34 12.64-2.79 15.79-6.28 1.5692838-1.6097281 2.4728795-3.752643 2.53-6v-4.62z"
          fill="#a56a43"
        ></path>
        <path
          id="Shape"
          d="m19.38 21.46c-.8982437-1.3139656-1.379197-2.8683509-1.38-4.46 0-5.63 6.48-10.35 15.17-11.64l16.44 1.88c5.68 2.45 10.13 7.27 7.76 12.82-2.22 5.21-10 9.05-19.37 9.05-1.26 0-1.61-.05-1.72-.05z"
          fill="#cb8252"
        ></path>
        <path
          id="Shape"
          d="m53.5 19c-1.78 3.45-8 6-15.5 6-2.6132723.0169333-5.2168425-.3194453-7.74-1l-7-3.9c-.4686178-.530036-.8257143-1.1490031-1.05-1.82 2.78-1.74 7.09-5 7.8-8.2.99-4.46 8.85-9.57 12.99-9.08 4.84.63 7.38 7.86 9.91 13.06.15.31.88 1.79 1 1.86.2641676 1.0412097.117347 2.1441542-.41 3.08z"
          fill="#c03a2b"
        ></path>
        <path
          id="Shape"
          d="m30 10.08c-.72 3.2-5 6.47-7.8 8.2-1.27-4.11 3.6-7 7.8-8.2z"
          fill="#805333"
        ></path>
        <g fill="#e64c3c">
          <circle id="Oval" cx="37" cy="9" r="1"></circle>
          <circle id="Oval" cx="43" cy="12" r="1"></circle>
          <circle id="Oval" cx="42" cy="18" r="1"></circle>
          <circle id="Oval" cx="35" cy="15" r="1"></circle>
          <circle id="Oval" cx="43" cy="7" r="1"></circle>
        </g>
        <path
          id="Shape"
          d="m37.47 46.62-.22 1.08c-1.2898908 6.5627665-7.0416736 11.2965717-13.73 11.3h-7c-6.70336918.015713-12.47722224-4.7224525-13.77-11.3l-.22-1.08z"
          fill="#805333"
        ></path>
        <path
          id="Shape"
          d="m0 36v4.62c0 6.81 9 12.38 20 12.38s20-5.52 20-12.33v-4.67z"
          fill="#cb8252"
        ></path>
        <path
          id="Shape"
          d="m15.17 24.36c-8.69 1.29-15.17 6.01-15.17 11.64 0 6.66 9 12.06 20 12.06 9.32 0 17.15-3.84 19.37-9 2.36-5.53-2-10.36-7.76-12.82z"
          fill="#cf976a"
        ></path>
        <path
          id="Shape"
          d="m35.5 38c-1.78 3.45-8 6-15.5 6s-13.72-2.55-15.5-6c-.11691361-.2325977-.21716565-.4732026-.3-.72 2.78-1.74 7.09-5 7.8-8.2 1-4.46 8.86-9.57 13-9 4.84.63 7.38 7.86 9.91 13.06.15.31.88 1.79 1 1.86.2430507 1.0160981.096779 2.0863786-.41 3z"
          fill="#f0c419"
        ></path>
        <path
          id="Shape"
          d="m12 29.08c-.72 3.2-5 6.47-7.8 8.2-1.27-4.11 3.6-7 7.8-8.2z"
          fill="#805333"
        ></path>
        <circle id="Oval" cx="19" cy="29" fill="#f29c1f" r="1"></circle>
        <circle id="Oval" cx="27" cy="34" fill="#f29c1f" r="1"></circle>
        <circle id="Oval" cx="21" cy="39" fill="#f29c1f" r="1"></circle>
        <circle id="Oval" cx="13" cy="38" fill="#f29c1f" r="1"></circle>
        <circle id="Oval" cx="25" cy="26" fill="#f29c1f" r="1"></circle>
      </g>
    </svg>
  ),
  item4: (props) => (
    <svg
      id="fi_9418573"
      enable-background="new 0 0 511.999 511.999"
      height="512"
      viewBox="0 0 511.999 511.999"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m222.26 79.97v34.295l-67.798 25.013-67.787-25.013v-34.295c0-20.934 16.978-37.911 37.911-37.911h59.762c20.935-.001 37.912 16.977 37.912 37.911z"
          fill="#f9f3f1"
        ></path>
        <path d="m86.676 98.627h135.584v20.789l-67.797 25.013-67.787-25.013z" fill="#f3eae6"></path>
        <path
          d="m222.257 79.974v34.29l-67.788 25.012-20.216-7.466 47.561-17.546v-34.29c0-20.943-16.971-37.915-37.914-37.915h40.443c20.943 0 37.914 16.971 37.914 37.915z"
          fill="#f3eae6"
        ></path>
        <path
          d="m214.849 469.941h-120.762c-72.39 0-117.581-78.425-81.281-141.056l35.151-60.648c24.915-42.986 38.036-91.79 38.036-141.475h136.95c0 49.685 13.121 98.488 38.036 141.475l35.151 60.648c36.3 62.631-8.891 141.056-81.281 141.056z"
          fill="#c8effe"
        ></path>
        <path
          d="m214.843 469.941h-30.275c36.102 0 58.63-78.422 40.53-141.056l-17.525-60.648c-6.218-21.486-10.949-44.436-14.139-68.222s-4.829-48.408-4.829-73.257h34.334c0 24.85 3.277 49.471 9.668 73.257 6.402 23.786 15.908 46.737 28.365 68.222l35.158 60.648c36.297 62.634-8.898 141.056-81.287 141.056z"
          fill="#99e6fc"
        ></path>
        <path
          d="m268.037 406.645c-10.2 17.709-27.834 28.854-47.898 30.514-1.747.152-3.516.228-5.295.228h-119.929c-22.159 0-42.939-11.524-54.007-30.72-11.101-19.261-11.079-42.222.065-61.462l20.01-34.518c4.286-7.39 12.186-11.947 20.737-11.947h145.495c8.551 0 16.451 4.557 20.737 11.947l20.01 34.518c11.143 19.229 11.175 42.19.075 61.44z"
          fill="#f9f3f1"
        ></path>
        <path
          d="m268.037 406.645c-10.2 17.709-27.834 28.854-47.898 30.514 12.153-28.604 15.669-71.206 4.959-108.274l-8.714-30.145h10.83c8.551 0 16.451 4.557 20.737 11.947l20.01 34.518c11.144 19.229 11.176 42.19.076 61.44z"
          fill="#f3eae6"
        ></path>
        <path
          d="m162.056 114.269h-72.181c-13.813 0-25.01 11.197-25.01 25.01 0 13.813 11.197 25.01 25.01 25.01h129.186c13.813 0 25.01-11.197 25.01-25.01 0-13.812-68.202-25.01-82.015-25.01z"
          fill="#f9f3f1"
        ></path>
        <path
          d="m244.071 139.279c0 13.814-11.198 25.012-25.012 25.012h-57.002c13.814 0 25.001-11.198 25.001-25.012 0-6.902-2.799-13.163-7.325-17.688-4.525-4.525-10.775-7.325-17.677-7.325h57.002c6.912 0 13.163 2.8 17.687 7.325 4.526 4.526 7.326 10.787 7.326 17.688z"
          fill="#f3eae6"
        ></path>
        <g fill="#f3eae6">
          <path d="m80.744 408.939c-4.268 0-7.727-3.459-7.727-7.727v-.163c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.163c-.001 4.268-3.46 7.727-7.727 7.727z"></path>
          <path d="m70.633 385.96c-4.268 0-7.727-3.459-7.727-7.727v-.162c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.162c-.001 4.267-3.46 7.727-7.727 7.727z"></path>
          <path d="m96.369 391.475c-4.268 0-7.727-3.459-7.727-7.727v-.163c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.163c-.001 4.268-3.46 7.727-7.727 7.727z"></path>
        </g>
        <path
          d="m425.323 79.97v34.295l-67.787 25.013-67.798-25.013v-34.295c0-19.955 15.432-36.325 35.016-37.798.958-.072 1.916-.113 2.895-.113h59.762c.979 0 1.937.041 2.895.113 19.585 1.473 35.017 17.843 35.017 37.798z"
          fill="#f9f3f1"
        ></path>
        <path
          d="m425.323 98.627v20.789l-67.787 25.013-67.797-25.013v-20.789z"
          fill="#f3eae6"
        ></path>
        <path
          d="m425.321 79.974v34.29l-67.788 25.012-20.216-7.466 47.561-17.546v-34.29c0-20.943-16.971-37.915-37.914-37.915h40.443c20.942 0 37.914 16.971 37.914 37.915z"
          fill="#f3eae6"
        ></path>
        <path
          d="m417.913 469.941h-120.763c-72.39 0-117.581-78.425-81.281-141.056l35.151-60.648c24.915-42.986 38.036-91.79 38.036-141.475h136.95c0 49.685 13.121 98.488 38.036 141.475l35.151 60.648c36.301 62.631-8.89 141.056-81.28 141.056z"
          fill="#c8effe"
        ></path>
        <path
          d="m417.906 469.941h-30.275c36.102 0 58.63-78.422 40.53-141.056l-17.525-60.648c-6.218-21.486-10.949-44.436-14.139-68.222s-4.829-48.408-4.829-73.257h34.334c0 24.85 3.277 49.471 9.668 73.257 6.402 23.786 15.908 46.737 28.365 68.222l35.158 60.648c36.298 62.634-8.898 141.056-81.287 141.056z"
          fill="#99e6fc"
        ></path>
        <path
          d="m471.1 406.645c-10.2 17.709-27.834 28.854-47.898 30.514-1.747.152-3.516.228-5.295.228h-119.929c-22.159 0-42.939-11.524-54.007-30.72-11.101-19.261-11.079-42.222.065-61.462l20.01-34.518c4.286-7.39 12.186-11.947 20.737-11.947h145.495c8.551 0 16.451 4.557 20.737 11.947l20.01 34.518c11.143 19.229 11.176 42.19.075 61.44z"
          fill="#025f80"
        ></path>
        <path
          d="m471.1 406.645c-10.2 17.709-27.834 28.854-47.898 30.514 12.153-28.604 15.669-71.206 4.959-108.274l-8.714-30.145h10.83c8.551 0 16.451 4.557 20.737 11.947l20.01 34.518c11.144 19.229 11.177 42.19.076 61.44z"
          fill="#024c67"
        ></path>
        <path
          d="m365.12 114.269h-72.181c-13.813 0-25.01 11.197-25.01 25.01 0 13.813 11.197 25.01 25.01 25.01h129.186c13.813 0 25.01-11.197 25.01-25.01-.001-13.812-68.202-25.01-82.015-25.01z"
          fill="#f9f3f1"
        ></path>
        <path
          d="m447.134 139.279c0 13.814-11.198 25.012-25.012 25.012h-57.002c13.814 0 25.001-11.198 25.001-25.012 0-6.902-2.799-13.163-7.325-17.688-4.525-4.525-10.775-7.325-17.677-7.325h57.002c6.912 0 13.163 2.8 17.687 7.325 4.527 4.526 7.326 10.787 7.326 17.688z"
          fill="#f3eae6"
        ></path>
        <g fill="#024c67">
          <path d="m283.807 408.939c-4.268 0-7.727-3.459-7.727-7.727v-.163c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.163c-.001 4.268-3.46 7.727-7.727 7.727z"></path>
          <path d="m273.696 385.96c-4.268 0-7.727-3.459-7.727-7.727v-.162c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.162c-.001 4.267-3.459 7.727-7.727 7.727z"></path>
          <path d="m299.433 391.475c-4.268 0-7.727-3.459-7.727-7.727v-.163c0-4.267 3.459-7.727 7.727-7.727s7.727 3.459 7.727 7.727v.163c-.001 4.268-3.459 7.727-7.727 7.727z"></path>
        </g>
        <g fill="#025f80">
          <path d="m162.2 42.058v21.655c0 4.265-3.461 7.727-7.727 7.727-4.275 0-7.727-3.461-7.727-7.727v-21.655z"></path>
          <g>
            <path d="m340.208 42.058v21.655c0 4.265-3.451 7.727-7.727 7.727-4.265 0-7.727-3.461-7.727-7.727v-21.541c.958-.072 1.916-.113 2.895-.113h12.559z"></path>
            <path d="m390.307 42.172v21.542c0 4.265-3.462 7.727-7.727 7.727s-7.727-3.461-7.727-7.727v-21.656h12.558c.98 0 1.938.042 2.896.114z"></path>
            <path d="m365.263 42.058v21.655c0 4.265-3.462 7.727-7.727 7.727-4.275 0-7.727-3.461-7.727-7.727v-21.655z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  item5: (props) => (
    <svg
      id="fi_3348042"
      enable-background="new 0 0 497.4 497.4"
      height="512"
      viewBox="0 0 497.4 497.4"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="m356.369 447.482-25.225-19.806-20.567 21.993-20.567-21.993-20.567 21.993-20.564-21.993-20.565 21.993-20.569-21.993-20.566 21.993-20.567-21.993-20.568 21.993-20.57-21.993-20.571 21.993-20.571-21.993-20.571 21.993-20.575-21.993-25.231 19.807v-445.296l25.226 19.807 20.566-21.994 20.568 21.994 20.567-21.994 20.563 21.994 20.566-21.994 20.569 21.994 20.565-21.994 20.568 21.994 20.568-21.994 20.57 21.994 20.571-21.994 20.57 21.994 20.572-21.994 20.574 21.994 25.231-19.808z"
                fill="#ff6363"
              ></path>
              <g>
                <path
                  d="m331.138 21.994-14.769-15.789v437.271l14.775-15.8 25.225 19.806v-445.296z"
                  fill="#f74d4d"
                ></path>
              </g>
              <path
                d="m356.369 447.482-25.225-19.806-20.567 21.993-20.567-21.993-20.567 21.993-20.564-21.993-20.565 21.993-20.569-21.993-20.566 21.993-20.567-21.993-20.568 21.993-20.57-21.993-20.571 21.993-20.571-21.993-20.571 21.993-20.575-21.993-25.231 19.807v-445.296l25.226 19.807 20.566-21.994 20.568 21.994 20.567-21.994 20.563 21.994 20.566-21.994 20.569 21.994 20.565-21.994 20.568 21.994 20.568-21.994 20.57 21.994 20.571-21.994 20.57 21.994 20.572-21.994 20.574 21.994 25.231-19.808z"
                fill="none"
              ></path>
            </g>
            <path d="m17.955 65.002h338.414v319.666h-338.414z" fill="#ff9696"></path>
            <path d="m316.369 65.002h40v319.666h-40z" fill="#ff8080"></path>
            <g>
              <ellipse cx="187.162" cy="224.835" fill="#fff9eb" rx="105.633" ry="105.038"></ellipse>
              <g>
                <g>
                  <path
                    d="m297.462 269.644h-220.6c-12.227 0-22.139-9.912-22.139-22.139v-.112c0-37.207 30.162-67.369 67.369-67.369h130.139c37.207 0 67.369 30.162 67.369 67.369v.112c0 12.227-9.912 22.139-22.138 22.139z"
                    fill="#cf7a15"
                  ></path>
                </g>
                <path
                  d="m252.231 180.025h-40c37.207 0 67.369 30.162 67.369 67.369v.112c0 12.227-9.912 22.139-22.139 22.139h40c12.227 0 22.139-9.912 22.139-22.139v-.112c0-37.207-30.162-67.369-67.369-67.369z"
                  fill="#c4710e"
                ></path>
                <g fill="#a1550a">
                  <path d="m144.911 180.025v26.169c0 7.09-5.737 12.838-12.814 12.838s-12.814-5.748-12.814-12.838v-26.169z"></path>
                  <path d="m199.976 180.025v34.727c0 7.09-5.737 12.838-12.814 12.838s-12.814-5.748-12.814-12.838v-34.727z"></path>
                  <path d="m255.041 180.025v26.169c0 7.09-5.737 12.838-12.814 12.838s-12.814-5.748-12.814-12.838v-26.169z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <path
            d="m229.213 484.434c78.88 17.242 161.259 17.288 240.159.139 8.217-1.786 12.49-10.913 8.647-18.392-13.57-26.407-42.537-79.22-57.161-79.22-11.999 0-25.499 23.132-35.998 23.132s-50.997-95.251-74.996-93.89c-19.627 1.113-71.36 110.535-89.554 150.361-3.396 7.433.92 16.125 8.903 17.87z"
            fill="#fff4db"
          ></path>
          <g fill="#ffecbf">
            <path d="m344.86 410.094c7.401 0 16.292-11.486 25.097-18.27-17.031-27.589-42.831-76.599-60.093-75.62-4.554.258-10.839 6.354-18.03 16.053 21.592 26.826 45.342 77.837 53.026 77.837z"></path>
            <path d="m478.019 466.181c-13.57-26.407-42.537-79.22-57.161-79.22-7.048 0-14.612 7.978-21.783 14.564 13.942 17.592 29.879 47.015 38.944 64.656 3.843 7.479-.43 16.606-8.647 18.392-32.813 7.132-66.228 11.279-99.742 12.463 46.843 1.651 93.88-2.495 139.742-12.463 8.217-1.786 12.49-10.913 8.647-18.392z"></path>
          </g>
          <g>
            <path
              d="m303.47 384.618c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
              fill="#edcb7e"
            ></path>
          </g>
          <g>
            <path
              d="m345.468 439.047c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
              fill="#edcb7e"
            ></path>
          </g>
          <g>
            <path
              d="m285.471 458.098c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
              fill="#edcb7e"
            ></path>
          </g>
          <g>
            <path
              d="m426.464 448.572c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
              fill="#edcb7e"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  item6: (props) => (
    <svg
      id="fi_6724509"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m509.529 127.744-17.896-17.896c-13.178-13.178-34.545-13.178-47.723 0l-328.097 328.096c-9.884 9.884-25.908 9.884-35.792 0l5.894 19.588c13.178 13.178 34.545 13.178 47.723 0l328.167-317.858c9.884-9.884 25.909-9.884 35.792 0 3.295 3.295 8.636 3.295 11.931 0 3.296-3.294 3.296-8.635.001-11.93z"
          fill="#a46a5a"
        ></path>
        <path
          d="m121.779 455.84c-6.589 6.589-17.272 6.589-23.862 0l-17.896-17.896c-3.295-3.295-8.636-3.295-11.931 0s-3.295 8.636 0 11.931l17.896 17.896c13.178 13.178 34.545 13.178 47.723 0l158.097-158.097 1.093-10.201 11.505-2.396 157.402-157.402c-6.589-6.589-17.272-6.589-23.862 0z"
          fill="#845252"
        ></path>
        <path
          d="m443.91 62.125-17.896-17.896c-13.178-13.178-34.545-13.178-47.723 0l-162.499 162.498 2.393 16.727-16.727-2.393-151.264 151.264c-9.884 9.884-25.908 9.884-35.792 0l5.894 19.588c13.178 13.178 34.545 13.178 47.723 0l328.168-317.857c9.884-9.884 25.909-9.884 35.792 0 3.295 3.295 8.636 3.295 11.931 0 3.294-3.295 3.294-8.637 0-11.931z"
          fill="#a46a5a"
        ></path>
        <path
          d="m56.16 390.221c-6.589 6.589-17.272 6.589-23.862 0l-17.896-17.896c-3.295-3.295-8.636-3.295-11.931 0s-3.295 8.636 0 11.931l17.896 17.896c13.178 13.178 34.545 13.178 47.723 0l109.88-109.88 74.531-46.229 32.329-60.63 111.357-111.357c-6.589-6.589-17.272-6.589-23.862 0z"
          fill="#845252"
        ></path>
        <g fill="#ffe077">
          <path d="m217.669 347.161c25.151-25.151 38.194-57.06 38.39-86.883-29.823.196-61.732 13.24-86.883 38.39-22.383 22.383-35.176 50.118-37.859 76.973-.538 5.389 3.991 9.918 9.379 9.379 26.856-2.683 54.591-15.477 76.973-37.859z"></path>
          <path d="m266.254 165.84c-8.193-30.575-25.816-55.523-47.731-71.274-4.397-3.16-10.584-1.503-12.812 3.433-11.104 24.598-13.892 55.015-5.699 85.591 9.206 34.356 30.318 61.606 56.048 76.688 14.741-25.927 19.4-60.082 10.194-94.438z"></path>
          <path d="m350.498 250.083c30.575 8.193 55.523 25.816 71.274 47.731 3.16 4.397 1.503 10.584-3.433 12.812-24.598 11.104-55.015 13.892-85.591 5.699-34.356-9.206-61.606-30.318-76.688-56.048 25.926-14.741 60.081-19.4 94.438-10.194z"></path>
        </g>
        <path
          d="m342.943 221.888c22.383-22.383 35.177-50.119 37.86-76.973.538-5.389-3.991-9.918-9.379-9.379-26.854 2.683-54.59 15.477-76.973 37.86-25.151 25.151-38.194 57.059-38.39 86.883 29.823-.198 61.731-13.241 86.882-38.391z"
          fill="#ffefac"
        ></path>
        <path
          d="m312.107 336.966c-9.206-34.356-30.318-61.607-56.048-76.688-14.742 25.926-19.4 60.082-10.195 94.438 8.193 30.575 25.815 55.522 47.731 71.274 4.397 3.161 10.585 1.503 12.813-3.433 11.104-24.599 13.892-55.016 5.699-85.591z"
          fill="#ffefac"
        ></path>
        <path
          d="m179.371 204.23c34.356 9.206 61.607 30.318 76.688 56.048-25.926 14.742-60.082 19.4-94.438 10.195-30.575-8.193-55.522-25.815-71.274-47.731-3.161-4.397-1.503-10.585 3.433-12.813 24.6-11.104 55.016-13.892 85.591-5.699z"
          fill="#ffefac"
        ></path>
        <g>
          <path
            d="m339.575 176.762c3.297 3.297 3.294 8.636 0 11.931l-53.688 53.688c-3.294 3.294-8.634 3.297-11.931 0s-3.294-8.636 0-11.931l53.688-53.688c3.295-3.294 8.634-3.297 11.931 0z"
            fill="#ffe077"
          ></path>
        </g>
        <g>
          <path
            d="m238.163 278.174c3.297 3.297 3.294 8.636 0 11.931l-53.688 53.688c-3.294 3.294-8.633 3.297-11.931 0-3.297-3.297-3.294-8.636 0-11.931l53.688-53.688c3.295-3.295 8.634-3.297 11.931 0z"
            fill="#ffd05b"
          ></path>
        </g>
        <g>
          <path
            d="m286.628 374.362c-4.504 1.207-9.127-1.465-10.332-5.965l-19.651-73.34c-1.206-4.5 1.461-9.125 5.965-10.332s9.127 1.465 10.332 5.965l19.651 73.34c1.207 4.5-1.46 9.125-5.965 10.332z"
            fill="#ffe077"
          ></path>
        </g>
        <g>
          <path
            d="m249.509 235.831c-4.504 1.207-9.127-1.465-10.332-5.965l-19.651-73.34c-1.206-4.5 1.461-9.125 5.965-10.332s9.127 1.465 10.332 5.965l19.651 73.34c1.206 4.5-1.461 9.125-5.965 10.332z"
            fill="#ffd05b"
          ></path>
        </g>
        <g>
          <path
            d="m141.975 229.709c-1.207 4.504 1.465 9.127 5.965 10.332l73.34 19.651c4.5 1.206 9.125-1.461 10.332-5.965s-1.465-9.127-5.965-10.332l-73.34-19.651c-4.499-1.206-9.125 1.461-10.332 5.965z"
            fill="#ffe077"
          ></path>
        </g>
        <g>
          <path
            d="m280.506 266.828c-1.207 4.504 1.465 9.127 5.965 10.332l73.34 19.651c4.5 1.206 9.125-1.461 10.332-5.965s-1.465-9.127-5.965-10.332l-73.34-19.651c-4.5-1.206-9.125 1.461-10.332 5.965z"
            fill="#ffd05b"
          ></path>
        </g>
        <path
          d="m286.632 283.504c4.553-.81 9.062-2.842 13.289-5.888 3.259-2.349 4.441-6.76 2.793-10.423-2.137-4.751-5.026-8.766-8.564-11.744-2.978-2.506-4.014-6.375-2.689-10.034 1.575-4.348 2.07-9.269 1.545-14.453-.405-3.996-3.634-7.225-7.63-7.63-5.183-.525-10.105-.031-14.453 1.545-3.659 1.326-7.528.289-10.034-2.688-2.978-3.538-6.992-6.427-11.744-8.564-3.664-1.648-8.075-.466-10.423 2.793-3.046 4.226-5.078 8.736-5.888 13.289-.681 3.832-3.514 6.664-7.345 7.345-4.553.81-9.062 2.842-13.289 5.888-3.259 2.349-4.441 6.76-2.793 10.424 2.137 4.751 5.026 8.766 8.564 11.744 2.978 2.506 4.014 6.375 2.688 10.034-1.575 4.348-2.07 9.269-1.545 14.453.405 3.996 3.634 7.225 7.63 7.63 5.183.525 10.105.031 14.453-1.545 3.659-1.326 7.528-.289 10.034 2.688 2.978 3.538 6.992 6.427 11.744 8.564 3.664 1.648 8.075.466 10.424-2.793 3.046-4.226 5.078-8.735 5.888-13.289.681-3.832 3.513-6.664 7.345-7.346z"
          fill="#ffefac"
        ></path>
        <g>
          <path
            d="m281.581 266.796c-6.717-6.717-9.196-16.379-6.504-25.536-9.359 2.741-19.332-.184-25.973-6.953-2.319 9.484-9.557 16.711-19.015 19.015 7.093 6.644 9.702 16.617 6.956 25.97 9.356-2.75 19.353.14 25.97 6.956 2.319-9.484 9.557-16.711 19.015-19.015-.148-.142-.297-.285-.449-.437zm8.014 33.314c.012 0 .015-.003.023 0-.009-.003-.012 0-.023 0z"
            fill="#fff"
          ></path>
        </g>
        <circle cx="256.06" cy="260.278" fill="#ffe077" r="8.436"></circle>
      </g>
    </svg>
  ),
  item7: (props) => (
    <svg
      id="fi_3404342"
      enable-background="new 0 0 128 128"
      height="512"
      viewBox="0 0 128 128"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m89.291 23.347v-11.588l-50.039-6.492v11.458l-14.375 26.578v71.456l48.195 7.74 30.051-7.902v-71.416zm9.832 21.091v64.629l-10.087-7.528.234-71.229zm-14.088 57.407-10.063 12.824v-62.964l10.292-19.576zm2.366 3.464 9.2 6.867-18.382 4.833zm-45.055-85.896 35.882 5.255.58-3.958-35.556-5.208v-5.683l42.039 5.454v8.208l-13.42 25.527-41.894-6.727zm-13.469 26.743 42.095 6.76v17.75c-2.252.157-4.727.829-7.393 2.012-5.561 2.501-8.258-.424-12.201-5.401-3.011-3.802-6.422-8.105-12.103-7.598-3.081.271-5.794 1.391-8.066 3.328l2.595 3.044c1.627-1.387 3.586-2.19 5.828-2.388 3.527-.315 5.884 2.654 8.611 6.098 2.843 3.589 6.22 7.853 11.577 7.853 1.606 0 3.39-.384 5.391-1.283 2.125-.942 4.053-1.491 5.762-1.648v43.428l-42.095-6.759v-65.196z"></path>
    </svg>
  ),
  teaBag: (props) => (
    <svg
      clip-rule="evenodd"
      fill-rule="evenodd"
      height="512"
      image-rendering="optimizeQuality"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_10105936"
      {...props}
    >
      <g id="Layer_x0020_1">
        <g id="_1994413822768">
          <path
            d="m410.36 280.99c-1.49 0-2.98-.55-4.14-1.66-20.52-19.58-43.74-66.95-68.33-117.1-33.8-68.95-75.88-154.76-107.32-150-16.2 2.45-39.59 31.45-59.02 155.66-.51 3.28-3.58 5.52-6.85 5-3.27-.51-5.51-3.58-5-6.85 16.97-108.46 38.92-161.11 69.08-165.68 18.83-2.85 38.57 12.61 62.11 48.63 19.45 29.77 38.93 69.52 57.78 107.96 24.1 49.16 46.86 95.59 65.83 113.7 2.4 2.29 2.49 6.09.2 8.48-1.18 1.24-2.76 1.86-4.34 1.86z"
            fill="#545355"
          ></path>
          <path
            d="m33.83 387.45v-151.54c0-1.58.62-3.09 1.72-4.21l67.82-68.94c1.12-1.15 2.66-1.79 4.27-1.79h115.65c1.61 0 3.15.64 4.28 1.79l67.81 68.94c1.1 1.12 1.72 2.63 1.72 4.21v131.02c-31.28 18.09-75.72 31.18-128.88 11.89-54.52-19.77-100.57-8.87-134.39 8.63z"
            fill="#cad0d7"
          ></path>
          <path
            d="m291.1 511.97h-251.27c-3.31 0-6-2.69-6-6v-100.1-18.42c33.82-17.5 79.87-28.4 134.39-8.63 53.16 19.29 97.6 6.2 128.88-11.89v18.42 120.62c0 3.31-2.68 6-6 6z"
            fill="#8c3f0a"
          ></path>
          <path
            d="m145.74 241.95h-37.83c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h37.83c3.32 0 6 2.68 6 6 0 3.31-2.68 6-6 6z"
            fill="#8d8f91"
          ></path>
          <path
            d="m223.03 241.95h-37.84c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h37.84c3.31 0 6 2.68 6 6 0 3.31-2.69 6-6 6z"
            fill="#8d8f91"
          ></path>
          <path
            d="m406.74 370.75c-10.39 0-19.46-6.65-22.56-16.54l-15-47.85c-1.88-6-1.31-12.39 1.62-17.99s7.84-9.72 13.84-11.6l47.85-15c2.28-.72 4.65-1.08 7.03-1.08 10.39 0 19.46 6.65 22.56 16.54l15 47.85c1.88 6 1.31 12.39-1.62 17.99s-7.84 9.72-13.84 11.6l-47.85 15c-2.29.72-4.65 1.08-7.03 1.08z"
            fill="#6ca13f"
          ></path>
          <path
            d="m284.23 506.34h-250.39c.2 3.14 2.8 5.63 5.99 5.63h251.27c3.32 0 6-2.69 6-6v-120.62-18.42c-2.22 1.29-4.52 2.55-6.87 3.78v9.02 120.62c0 3.31-2.69 5.99-6 5.99z"
            fill="#713308"
          ></path>
        </g>
      </g>
    </svg>
  ),
  chocolate2: (props) => (
    <svg id="fi_10656487" enable-background="new 0 0 256 256" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" {...props}><g><g><g><g><path d="m183.675 32.135h-111.35c-2.688 0-4.866 2.179-4.866 4.866v131.637l121.082-31.959v-99.677c0-2.688-2.179-4.867-4.866-4.867z" fill="#e6e7e8"></path></g></g><g><path d="m73.46 141.75c-1.1 0-2-.9-2-2v-101.61c0-.53.21-1.05.58-1.42.38-.37.89-.58 1.42-.58h48.39c1.1 0 2 .89 2 2 0 1.1-.9 1.99-2 1.99h-46.39v99.62c0 1.1-.9 2-2 2zm56.39-101.62c-1.11 0-2-.89-2-1.99 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.9 1.99-2 1.99z" fill="#f1f2f2"></path></g><g><g><path d="m104.235 32.515h6.086v136.123h-6.086z" fill="#d1d3d4"></path></g><g><path d="m145.679 32.515h6.086v136.123h-6.086z" fill="#d1d3d4"></path></g></g><g><g><path d="m67.459 73.579h121.082v6.086h-121.082z" fill="#d1d3d4"></path></g><g><path d="m67.459 121.109h121.082v6.086h-121.082z" fill="#d1d3d4"></path></g></g><g><path d="m183.675 32.135h-5.134v94.544l-111.082 29.32v12.639l121.082-31.959v-99.677c0-2.688-2.179-4.867-4.866-4.867z" fill="#d1d3d4"></path></g></g><g><path d="m184.541 223.865h-113.082c-2.209 0-4-1.791-4-4v-51.226l121.082-31.959v83.185c0 2.209-1.791 4-4 4z" fill="#ffa91a"></path></g><g><path d="m178.541 139.319v70.546c0 2.209-1.791 4-4 4h-107.082v6c0 2.209 1.791 4 4 4h113.082c2.209 0 4-1.791 4-4v-83.185z" fill="#f79219"></path></g><g><path d="m183.541 137.999v76.866c0 2.209-1.791 4-4 4h-112.082v1c0 2.209 1.791 4 4 4h113.082c2.209 0 4-1.791 4-4v-83.185z" fill="#ef7816"></path></g><g><path d="m67.459 193.469h121.082v9.499h-121.082z" fill="#fcc4ae"></path></g><g><path d="m178.541 193.469h10v9.499h-10z" fill="#f2ad97"></path></g></g></svg>
  ),
};
